const en = {
  nav: {
    approvals: 'Approvals',
    home: 'Home',
    search: 'Search',
    dashboard: 'Dashboard',
    outdoors: 'Outdoors',
    campaigns: 'Campaigns',
    admin: 'Admin',
    logIn: 'Log in',
    signUp: 'Sign up',
    logOut: 'Log out',
    account: 'Account',
    setupBusiness: 'Set up Business',
    searchOutdoors: 'Search Outdoors',
    manageOutdoors: 'Manage Outdoors',
    verifyOutdoors: 'Verify Outdoors',
    adminPanel: 'Admin Panel',
    upcomingCampaigns: 'Upcoming Campaigns',
    getPaid: 'Get Paid',
    revenue: 'Revenue',
    payments: 'Payments',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    back: 'Back',
    next: 'Next',
    done: 'Done',
    loading: 'Loading…',
    error: 'Something went wrong',
    confirm: 'Confirm',
    delete: 'Delete',
    clear: 'Clear',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    view: 'View',
    create: 'Create',
    update: 'Update',
    submit: 'Submit',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    upload: 'Upload',
    uploading: 'Uploading…',
    saving: 'Saving…',
    creating: 'Creating…',
    noResults: 'No results found',
    required: 'Required',
    optional: 'Optional',
    copy: 'Copy',
    copied: 'Copied!',
    approve: 'Approve',
    reject: 'Reject',
    page: 'Page',
    of: 'of',
    perDay: '/day',
    days: '{{count}} day',
    days_plural: '{{count}} days',
    termsAndConditions: 'Terms & Conditions',
    selectCountry: 'Select a country...',
    noCountriesFound: 'No countries found',
    notSet: 'Not set',
    pageOf: 'Page {{current}} of {{total}}',
    totalItems: '{{count}} total',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    refresh: 'Refresh',
    new: 'New',
    rowsPerPage: 'Rows per page',
  },
  home: {
    tagline: 'The OOH marketplace - it\'s ooh good!',
    heroTitle: 'Out-of-home advertising, made simple',
    heroSubtitle:
      'Scapow is the adtech marketplace connecting billboard and static outdoor owners with advertisers. Browse real OOH spaces, plan multi-location campaigns, and reach your audience - all in one platform.',
    browseOutdoors: 'Browse Outdoor Spaces',
    getStartedFree: 'Get Started Free',
    featuredOutdoors: 'Featured Outdoor Spaces',
    viewAll: 'View all →',
    howItWorksTitle: 'How OOH advertising works on Scapow',
    howItWorksSubtitle: 'Three simple steps to get your out-of-home ad campaign live and in front of the right audience.',
    step1Title: 'Find the perfect outdoor space',
    step1Desc:
      'Search static outdoor billboards by location, size, and price. Filter by availability for your campaign dates and target the streets that matter.',
    step2Title: 'Build your OOH campaign',
    step2Desc:
      'Add multiple outdoor placements to a single campaign, upload your print-ready creatives, and confirm your booking in minutes.',
    step3Title: 'Track your results',
    step3Desc:
      'Monitor campaign progress, banner placement status, and performance metrics directly from your advertiser dashboard.',
    builtTitle: 'Built for the whole OOH ecosystem',
    builtSubtitle:
      'Whether you own static outdoor spaces or want to run out-of-home ad campaigns, Scapow has you covered.',
    feature1Title: 'List your outdoor spaces',
    feature1Desc:
      'Placement providers can list static billboards and outdoor media with photos, accurate dimensions, and competitive day rates - discoverable by advertisers instantly.',
    feature2Title: 'Map-based OOH search',
    feature2Desc:
      'Find outdoor advertising locations on a live map. Zoom into your target street or zoom out for a city-wide out-of-home media plan.',
    feature3Title: 'End-to-end campaign management',
    feature3Desc:
      'Create OOH campaigns with multiple outdoor placements, upload print-ready creatives per location, and pay with a simple bank transfer.',
    feature4Title: 'Verified businesses',
    feature4Desc: 'Every advertiser and placement provider is verified with company documents before going live on the platform.',
    feature5Title: 'Adtech-grade tracking',
    feature5Desc:
      'Advertisers and placement providers both get real-time dashboard overviews of campaign activity, earnings, and spend - all in one adtech platform.',
    feature6Title: 'Transparent OOH pricing',
    feature6Desc: 'Placement provider day rates are shown upfront - always visible before you confirm your out-of-home booking.',
    ctaTitle: 'Ready to launch your OOH campaign?',
    ctaSubtitle: 'Join Scapow today and connect with the out-of-home advertising market - static outdoors, real locations, real results.',
    createAccount: 'Create Account',
    browseFirst: 'Browse First',
    nearbyOutdoors: 'Outdoors Near You',
    detectingLocation: 'Detecting your location…',
    basedOnLocation: 'Based on your current location',
    welcomeBack: 'Welcome, {{name}}',
    fromCompany: 'from {{company}}',
    ppPrompt: 'Are all your outdoors ready to be in new Campaigns?',
    advertiserPrompt: 'Are you ready to create some Campaigns?',
    noCompanyPrompt: 'Set up your business to unlock all features.',
    goToDashboard: 'Go to Dashboard',
    inviteFrom: '{{company}} has invited you to join their team on Scapow.',
    inviteFromDesc: 'Accept to start collaborating on outdoor advertising campaigns.',
    inviteAccept: 'Accept Invitation',
    inviteDecline: 'Decline',
    inviteAccepted: "Welcome aboard! You've successfully joined {{company}}.",
    inviteDeclined: 'You have declined the invitation.',
    ppHowItWorksSubtitle: 'Everything you need to turn your static outdoor spaces into a steady out-of-home advertising revenue stream.',
    ppStep1Title: 'Showcase your outdoor spaces',
    ppStep1Desc: 'List your static billboards and OOH placements with photos, accurate dimensions, and competitive day rates - so advertisers planning out-of-home campaigns can instantly see their value.',
    ppStep2Title: 'Get discovered by advertisers',
    ppStep2Desc: 'Your outdoor spaces appear in map-based OOH searches by advertisers planning their next campaign. The right adtech match finds you.',
    ppStep3Title: 'Prove display, then get paid',
    ppStep3Desc: 'Upload photo proof once your static outdoor is live with the campaign creative. Payment is processed automatically once approved.',
  },
  auth: {
    login: {
      heroTitle: 'Connect your brand with the world. A new height at a time.',
      heroSubtitle:
        'The platform that links billboard owners with advertisers - simple, fast, and impactful.',
      title: 'Welcome back',
      subtitle: 'Sign in to your account to continue',
      email: 'Email address',
      password: 'Password',
      forgotPassword: 'Forgot password?',
      resendVerification: 'Resend verification email',
      signIn: 'Sign in',
      noAccount: "Don't have an account?",
      createOne: 'Create one',
      invalidCredentials: 'Invalid email or password. Please try again.',
    },
    register: {
      heroTitle: 'Join the outdoor advertising revolution',
      heroSubtitle:
        'Whether you own billboards or want to advertise, Scapow makes it seamless.',
      title: 'Create your account',
      subtitle: 'Start managing outdoor campaigns today',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email address',
      password: 'Password',
      confirmPassword: 'Confirm password',
      passwordHint: 'Minimum 8 characters',
      createAccount: 'Create account',
      alreadyHaveAccount: 'Already have an account?',
      signIn: 'Sign in',
      checkEmail: 'Check your email',
      checkEmailDesc:
        "We've sent a verification link to your email address. Click it to activate your account.",
      goToLogin: 'Go to login',
      termsAgreement: 'I have read and agree to the',
      termsLink: 'Terms and Conditions',
    },
    forgotPassword: {
      title: 'Reset your password',
      subtitle: "Enter your email and we'll send you a reset link",
      email: 'Email address',
      sendReset: 'Send reset link',
      backToLogin: 'Back to login',
      checkEmail: 'Check your email',
      checkEmailDesc:
        "If that address is registered, you'll receive a reset link shortly.",
    },
    resetPassword: {
      title: 'Set new password',
      subtitle: "Choose a strong password you'll remember.",
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      save: 'Save new password',
      submit: 'Update password',
    },
    verifyEmail: {
      verifying: 'Verifying your email…',
      success: 'Email verified!',
      successDesc: 'Your account is now active. You can sign in.',
      error: 'Verification failed',
      errorDesc: 'The link may be expired or invalid. Please register again.',
      goToLogin: 'Go to login',
      successDescBusiness: 'Your account is now active. You can sign in and set up your business.',
      returnToLogin: 'Return to login',
      resendButton: 'Request new verification link',
    },
    resendVerification: {
      title: 'Resend verification email',
      subtitle: "Enter your email and we'll send you a new verification link.",
      email: 'Email address',
      send: 'Send verification email',
      backToLogin: 'Back to login',
      checkEmail: 'Check your email',
      checkEmailDesc: "If your account is awaiting verification, we've sent a new link to your inbox.",
    },
  },
  business: {
    pendingVerification: 'Your business account is currently under review. Once our team has completed the validation process, you\'ll have full access to all Scapow features. In the meantime, please keep an eye on your inbox - we may reach out if any additional documentation is required.',
    setup: {
      title: 'Set up your Business',
      subtitle: 'Link your account to a business entity to start using Scapow.',
      ppTitle: 'Placement Provider',
      ppDesc: 'I own outdoor advertising spaces and want to rent them out.',
      advertiserTitle: 'Advertiser',
      advertiserDesc: 'I want to book outdoor advertising campaigns.',
      changeType: 'Change ↩',
      createCompany: 'Create new company',
      createCompanyDesc: 'Register your business on Scapow.',
      joinCompany: 'Join existing company',
      joinCompanyDesc: 'Request access to an already registered business.',
      registerTitle: 'Register your company',
      companyName: 'Company name',
      vatNumber: 'VAT number',
      companyEmail: 'Company email',
      currency: 'Preferred currency',
      currencyHint: 'ISO currency code, e.g. EUR, USD, GBP',
      country: 'Country',
      proofDocument: 'Company proof document',
      proofHint: 'PDF, JPG or PNG',
      uploadProof: 'Click to upload proof of company',
      createCompanyBtn: 'Create company',
      bankTitle: 'Bank details',
      bankSubtitlePP: 'Your IBAN and SWIFT/BIC will be used for payouts when your outdoor campaigns go live.',
      bankSubtitleAdvertiser: 'Your IBAN and SWIFT/BIC will be used to process refunds if a campaign is cancelled.',
      findTitle: 'Find your company',
      searchPlaceholder: 'Search by company name…',
      noCompanies: 'No companies found. Search by name.',
      requestAccess: 'Request access',
      requested: 'Requested',
      accessSentMsg:
        "Access request sent! An admin of the company needs to approve it. You'll be notified once approved.",
      pendingTitle: 'Access Request Pending',
      pendingDesc: "Your request to join {{name}} is being reviewed. You'll be notified once approved.",
      cancelRequest: 'Cancel Request',
      requestCancelled: 'Access request cancelled.',
      connectingToEntity: 'Connecting to your organization…',
      accessApproved: "Your access request was approved! You're now part of the team.",
      accessRejected: 'Your access request was rejected. Please create or join another business entity.',
      orSetupYourOwn: 'Or register your business or join an existing one below.',
      invitationsTitle: 'Pending Invitations',
      invitationsSubtitle: 'You have been invited to join a business. Accept or decline below.',
      invitedOn: 'Invited on',
      acceptInvitation: 'Accept',
      declineInvitation: 'Decline',
      invitationAccepted: 'Invitation accepted! Connecting to your organization…',
      invitationDeclined: 'Invitation declined.',
    },
    details: {
      title: 'Company Details',
      subtitle: 'Manage your company registration and banking information.',
      registrationTitle: 'Registration details',
      companyName: 'Company name',
      vatNumber: 'VAT number',
      companyEmail: 'Company email',
      currency: 'Preferred currency',
      country: 'Country',
      portugueseRegion: 'Portuguese Region',
      regionContinent: 'Continent',
      regionAzores: 'Azores',
      regionMadeira: 'Madeira',
      replaceProof: 'Replace proof document',
      uploadProof: 'Click to upload a new proof document',
      saveChanges: 'Save changes',
      addressSectionTitle: 'Address',
      addressLine: 'Address',
      addressLinePlaceholder: '123 Main St',
      city: 'City',
      postCode: 'Postal Code',
      state: 'State',
      stateHint: 'Required for USD payout accounts',
      selectState: 'Select a state',
      bankTitle: 'Bank details',
      bankSubtitle: 'Used for receiving payments from advertisers.',
      bankSubtitlePP: 'Your IBAN and SWIFT/BIC are used for payouts when campaigns go live.',
      bankSubtitleAdvertiser: 'Your IBAN and SWIFT/BIC are used for refunds when applicable.',
      bankClickUnlock: 'Locked - click to edit',
      iban: 'IBAN',
      swift: 'SWIFT / BIC',
      ibanHint: 'International Bank Account Number...',
      swiftHint: '8 or 11 characters: bank code (4) + country (2) + location (2) + optional branch (3)',
      accountNumber: 'Account Number',
      accountNumberHint: 'Your USD bank account number (4–17 digits)',
      saveBankDetails: 'Save bank details',
      verifiedLocked: 'Company name, VAT number and country are locked after verification.',
      verifiedBadge: 'Verified',
      pendingReviewTitle: 'Awaiting Approval',
      pendingReviewDesc: 'Your business registration is under review. You\'ll gain full platform access as soon as our team approves it - we\'ll notify you in real time.',
      verifiedTitle: 'Identity Verified',
      verifiedDesc: 'Your company identity has been confirmed. No further documentation is required.',
      proofCardTitle: 'Verification Document',
      proofCardDesc: 'Upload your company registration document to support the verification of your account. Our team will review it and reach out if anything else is needed.',
      proofCardSubmit: 'Submit for Review',
      proofCardSuccess: 'Document submitted successfully. Our team will review it and get in touch if anything else is needed.',
      proofCardValidatingTitle: 'Documents Under Review',
      proofCardValidatingDesc: 'Your verification documents have been received and are currently being reviewed by our team. We\'ll notify you as soon as the process is complete.',
      proofCardProcessingTitle: 'Processing File',
      proofCardProcessingDesc: 'We\'ve received your document and are automatically verifying it. This won\'t take long.',
      proofCardReplaceFile: 'Submitted the wrong file? Replace it',
    },
  },
  search: {
    instantBookingHint: 'Confirmed instantly, with no provider approval required',
    priceFilterLocked: 'Price filters are available once you’re logged in and linked to a business entity.',
    title: 'Search Outdoors',
    subtitle: 'Find billboard spaces on the map',
    filters: 'Filters',
    minWidth: 'Min width (m)',
    maxWidth: 'Max width (m)',
    minHeight: 'Min height (m)',
    maxHeight: 'Max height (m)',
    minPrice: 'Min price (€/day)',
    maxPrice: 'Max price (€/day)',
    providerName: 'Provider name',
    clearFilters: 'Clear filters',
    noResults: 'No outdoors found in this area',
    noResultsDesc: 'Try expanding the map view, refining your filters, or extending your campaign duration to broaden availability.',
    addToCart: 'Add to cart',
    inCart: 'In cart',
    selectDates: 'Select dates',
    from: 'From',
    to: 'To',
    results: 'results',
    loading: 'Loading outdoors…',
    resultsTab: 'Results ({{count}})',
    mapTab: 'Map',
    searching: 'Searching…',
    found: '{{count}} outdoor found',
    found_plural: '{{count}} outdoors found',
    moveMap: 'Move the map to update results',
    noticePeriodHint: 'Some placement providers require a minimum notice period before a campaign can start, or a minimum renting period, which may affect availability and search results.',
    noOutdoorsFound: 'No outdoors found',
    noOutdoorsFoundAdjustDates: 'Please try adjusting your start and end dates, or zooming out.',
    noOutdoorsFoundAdjustFilters: 'Try zooming out or adjusting your filters.',
    inCampaign: 'In campaign',
    attributes: 'Located near',
    withDiscounts: 'Volume discounts available',
    illuminated: 'Illuminated only',
    illuminatedHint: 'outdoor has illumination (ie, during the night)',
    containsDiscounts: 'Volume discounts',
    containsDiscountsDesc: 'This outdoor offers tiered pricing - the more days you book, the lower the daily rate.',
  },
  outdoor: {
    startAtMonthFirstDay: 'Start on the 1st of the month',
    startAtMonthFirstDayHint: 'Bookings must start on the 1st day of a month. With full months only, they run by whole calendar months (1st to last day).',
    acceptingToastOn: '{{name}} is now accepting new campaigns.',
    acceptingToastOff: '{{name}} is paused - hidden from search and closed to new bookings.',
    acceptingToastBulkOn: '{{count}} outdoor(s) now accepting new campaigns.',
    acceptingToastBulkOff: '{{count}} outdoor(s) paused - hidden from search and closed to new bookings.',
    fullMonthRequired: 'Full months only',
    fullMonthRequiredHint: 'Advertisers book by the month: from their start day to the same day of the following month (starting on the 1st, to the month’s last day), for as many consecutive months as they like.',
    fullMonthTooltip: 'Booked by the month - from the start day to the same day of a following month.',
    stepsTitle: 'Outdoor setup',
    stepNotSet: 'Not set yet',
    stepLocationSet: 'Pin placed',
    stepNoticeSummary: 'Notice: {{count}} day(s)',
    stepPhotosSummary: 'Photos: {{count}}',
    stepPhotosNone: 'No photos yet',
    stepBlockedSummary: 'Blocked periods: {{count}}',
    stepOptional: 'Optional',
    stepFeaturesSummary: 'Selected: {{count}}',
    fixHighlightedFields: 'Some details need fixing - we’ve opened the step with the problem.',
    instantBooking: 'Instant booking',
    instantBookingTooltip: 'Booked straight away - no need to wait for the provider’s confirmation.',
    instantBookingHint: 'Advertisers book this outdoor straight away, without waiting for your approval. Leave it off to review each booking first.',
    kmAway: '{{distance}} km away',
    productionCost: 'Production cost',
    productionCostIncludes: 'includes fees of printing, setup, etc.',
    priceHiddenTitle: 'Daily values are for business accounts',
    priceHiddenMessage: 'Please log in and make sure you’re linked to a business entity (placement provider or advertiser) to see the outdoor’s daily value.',
    manageTitle: 'Manage Outdoors',
    addNew: 'Add New Outdoor',
    noOutdoors: 'No outdoors yet',
    noOutdoorsDesc: 'Add your first billboard to start receiving bookings.',
    addFirst: 'Add your first outdoor',
    editTitle: 'Edit Outdoor',
    createTitle: 'Add New Outdoor',
    listSubtitle: 'List your billboard on Scapow.',
    editSubtitle: 'Update your billboard details.',
    location: 'Location',
    latitude: 'Latitude',
    longitude: 'Longitude',
    name: 'Name',
    namePlaceholder: 'e.g. Avenida da Liberdade – Billboard A',
    description: 'Description',
    descriptionPlaceholder: 'Prime billboard on Avenida da Liberdade, high traffic area…',
    dimensions: 'Dimensions & Specs',
    width: 'Width (m)',
    height: 'Height (m)',
    length: 'Length (m)',
    aspectRatio: 'Creative aspect ratio',
    aspectRatioHint: 'Auto-computed from width ÷ height',
    bleed: 'Bleed (m)',
    bleedHint: 'Print cutting margin - the extra image area beyond the final trim edge to ensure clean cuts.',
    illuminated: 'Illuminated',
    illuminatedHint: 'This outdoor has lighting, keeping it visible at night.',
    currency: 'Currency',
    currencyLockedHint: 'Set by your Placement Provider account\'s currency.',
    pricing: 'Pricing',
    excludeVat: 'exclude VAT',
    vatIncluded: 'VAT included',
    pricePerDay: 'Price per day',
    volumeDiscounts: 'Volume discounts',
    addDiscount: 'Add',
    daysArrow: 'days →',
    percentOff: '% off',
    photos: 'Location photos',
    photosHint: 'Photos are automatically saved when uploaded or removed.',
    uploadPhotos: 'Click to upload location photos',
    addMorePhotos: 'Add more photos',
    currentPhotos: 'Current photos',
    uploadingPhotos: 'Uploading photos...',
    photosUploaded: 'Photos uploaded successfully',
    deletePhotoTitle: 'Delete photo?',
    deletePhotoConfirm: 'This photo will be permanently removed from this outdoor.',
    filesSelected_one: '{{count}} file selected',
    filesSelected_other: '{{count}} files selected',
    blockedTimes: 'Blocked times',
    blockedTimesDesc:
      'Block dates when the outdoor is unavailable (maintenance, pre-booked externally, etc.).',
    blockedTimesOverlapNote: "Ranges can't overlap each other or any active campaign booking.",
    blockFrom: 'Block from',
    blockUntil: 'Block until',
    addBlockedTime: 'Add blocked time',
    noBlockedTimes: 'No blocked times',
    occupiedByCampaign: 'Booked by a campaign',
    unsaved: 'Unsaved',
    unsavedChanges: '{{count}} unsaved change(s) - save outdoor to apply',
    selectBlockedDates: 'Please select both a start and end date.',
    legalDeclaration: 'I declare that I have legal rights over this outdoor advertising space, that I am authorized to list it commercially, and that doing so complies with all applicable laws, permits, and regulations.',
    legalDeclarationRequired: 'You must confirm you have legal rights over this outdoor before listing it.',
    createOutdoor: 'Create outdoor',
    saveChanges: 'Save changes',
    deleteTitle: 'Delete Outdoor',
    deleteConfirm: 'Are you sure you want to delete this outdoor? This action cannot be undone.',
    hidden: 'Hidden',
    visible: 'Visible',
    viewDetails: 'View details',
    bookingRules: 'Booking rules',
    bookingRulesDesc: 'Define lead-time requirements advertisers must meet before the campaign start date.',
    minimumNoticeDays: 'Minimum notice (days)',
    minimumNoticeDaysHint: 'Campaigns must be fully paid and creative uploaded at least this many days before the start date.',
    minimumDays: 'Minimum rental duration (days)',
    minimumDaysHint: 'The minimum number of days advertisers must rent this outdoor for.',
    acceptingCampaigns: 'Accepting new campaigns',
    acceptingCampaignsOn: 'This outdoor is visible in search and can be added to campaigns.',
    acceptingCampaignsOff: 'This outdoor is hidden from search and will not receive new bookings.',
    acceptingBadge: 'Accepting campaigns',
    notAcceptingBadge: 'Not accepting campaigns',
    notAcceptingMsg: 'This outdoor is not accepting new campaigns at this time.',
    unavailableForDates: 'This outdoor is unavailable for the selected dates.',
    paused: 'Paused',
    accepting: 'Accepting',
    availabilityToggleTooltip: 'Whether this outdoor is available for campaigns or not. Current state: {{state}}',
    availabilityStateOn: 'Available',
    availabilityStateOff: 'Not Available',
    toggleError: 'Failed to update campaign visibility.',
    bulkAccept: 'Enable accepting campaigns for all outdoors on this page',
    bulkPause: 'Pause accepting campaigns for all outdoors on this page',
    commissionNote: 'Advertisers will be quoted <bold>{{currency}} {{advertiserPrice}}/day</bold> - your {{currency}} {{basePrice}} plus a <bold>{{rate}}% Scapow commission</bold>.',
    advertiserPaysLabel: 'Advertiser pays',
    advertiserPaysDesc: 'Includes {{rate}}% Scapow markup',
    youReceiveLabel: '{{name}} receives',
    youReceiveDesc: 'After {{rate}}% platform fee (VAT on commission may apply)',
    searchByAddress: 'Search by address',
    dragPin: 'Drag the pin to fine-tune the exact position.',
    status: 'Status',
    myOutdoors: 'My Outdoors',
    myOutdoorsSubtitle: 'Manage your billboard inventory',
    viewCalendarTooltip: 'Check out the blocked dates for this Outdoor',
    calendarModalTitle: 'Calendar - {{name}}',
    addOutdoor: 'Add Outdoor',
    searchByName: 'Search by name…',
    deleteConfirmNamed: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
    specifications: 'Specifications',
    creativeRatio: 'Creative ratio',
    coordinates: 'Coordinates',
    price: 'Price',
    plusVat: '+ VAT',
    unavailableDates: 'Unavailable dates',
    duration: 'Duration',
    addToCampaign: 'Add to Campaign',
    goToCampaign: 'Go to Campaign',
    signInToAdd: 'Login/Register to add this Outdoor to your Campaign',
    bookingsCalendarTitle: 'Bookings calendar',
    bookingsCalendarSubtitle: 'See when your campaigns go live, run and wrap up. Pick a day to see which outdoors are booked.',
    legend_starting: 'Campaign starts',
    legend_startingDesc: 'A booking goes live',
    legend_running: 'Campaign live',
    legend_runningDesc: 'Your outdoor is on air',
    legend_finishing: 'Campaign ends',
    legend_finishingDesc: 'Last day of a booking',
    legend_blocked: 'Blocked dates',
    legend_blockedDesc: 'Outdoors you made unavailable',
    legend_none: 'No bookings',
    legend_noneDesc: 'None of your outdoors are booked',
    legend_mixed: 'Split colours: more than one applies that day',
    calendarToday: 'Today',
    selectDayHint: 'Pick a day to see its bookings. Click it again to clear.',
    clearDateSelection: 'Clear date selection',
    dailyStatesError: 'We could not load this month’s bookings. Try refreshing.',
    searchBookedByName: 'Search booked outdoors by name…',
    clearSearch: 'Clear search',
    bookedOutdoorsCount: 'Booked outdoors: {{count}}',
    noBookingsOnDate: 'No outdoors booked on this day',
    noBookedOutdoorsMatch: 'No booked outdoors match “{{name}}” on this day',
    noBookingsOnDateHint: 'Pick another day, or clear the date to see all your outdoors.',
    bookingPeriod: 'Booking period',
    logIn: 'Log in',
    register: 'Register',
    selectCampaignToAdd: 'Please select a campaign to add this outdoor to',
    changeCampaign: 'Change',
    alreadyInCampaign: 'Already in campaign',
    billboardFallback: 'Outdoor Billboard',
    bookMoreThanDays: 'Book more than {{count}} days',
    percentageOff: '{{percentage}}% off',
    comingSoon: 'Your Outdoors will be here soon!',
    attributes: 'Located near',
    attributesHint: "Help advertisers find you faster. Tag what's nearby to boost your outdoor's visibility in search.",
  },
  outdoorDetail: {
    productionCost: 'Production cost',
    bookingTitle: 'Book this outdoor',
    startDate: 'Start date',
    endDate: 'End date',
    estimatedCost: 'Estimated cost',
    addToCart: 'Add to cart',
    inCart: 'Already in cart',
    specs: 'Specifications',
    dimensions: 'Dimensions',
    aspectRatio: 'Required aspect ratio',
    pricePerDay: 'Price per day',
    location: 'Location',
    blockedTimes: 'Blocked periods',
    discounts: 'Volume discounts',
    noBlockedTimes: 'No blocked periods',
    noDiscounts: 'No discounts available',
    photos: 'Photos',
    days: 'days',
    total: 'Total',
    discount: 'discount',
    campaignBookings: 'Campaign Bookings',
    inCampaign: 'In Campaign',
    minimumNoticeInDays: 'Minimum booking notice',
  },
  campaign: {
    methodFlowLabel: 'How you’ll pay',
    methodFirstPayment: '1st payment',
    methodCard: 'Card',
    methodThenMonthly: 'Then monthly',
    methodThenTrimonthly: 'Then every 3 months',
    methodDirectDebit: 'Direct debit',
    searchByName: 'Search campaigns by name…',
    clearSearch: 'Clear search',
    resultsSummary: 'Results: {{total}} · Page {{page}} of {{pages}}',
    noSearchResults: 'No campaigns match “{{name}}”',
    noSearchResultsHint: 'Check the spelling or try another name.',
    eventFeedbackReceived: 'A provider has answered on your campaign’s outdoors.',
    eventConfirmationUpdated: 'Your campaign’s confirmation is complete - check its new status.',
    eventViewCampaign: 'View campaign',
    planTrimonthlyTitle: 'Pay every 3 months',
    planTrimonthlyDesc: 'Pay production costs and your first 3 months now. Each following 3-month period is collected by direct debit on its 1st day.',
    visitCampaignPage: 'Visit campaign page',
    payStepNotice: 'Outdoor availability is re-checked when you pay - if anything changed, we’ll tell you before you’re charged.',
    removeOutdoor: 'Remove this outdoor',
    noOutdoorsYetDesc: 'Browse the map to find outdoors for your campaign, then pick your dates.',
    creativesNeedOutdoors: 'Add outdoors first - the creatives you need depend on their sizes.',
    stepAnnounce: 'Step {{n}} of {{total}}: {{step}}',
    stepsDone: '{{done}} of {{total}} done',
    stepDone: 'Done',
    stepToDo: 'To do',
    stepPrevious: 'Back: {{step}}',
    stepNext: 'Next: {{step}}',
    stepOutdoorsSummary: 'Outdoors: {{count}}',
    stepCreativesSummary: '{{done}} of {{total}} ready',
    stepTermsAccepted: 'Accepted',
    stepTermsPending: 'Not accepted yet',
    stepPendingHint_outdoors: 'Add at least one outdoor to continue.',
    stepPendingHint_creatives: 'Every required creative must be uploaded and approved.',
    stepPendingHint_terms: 'Accept the terms to unlock payment.',
    goToPayment: 'Go to payment',
    acceptTermsStepLabel: 'I have read and accept the Terms and Conditions for this campaign.',
    payStepTitle: 'Review and pay',
    payStepMissingTitle: 'Complete these steps to pay:',
    payStepTotal: 'Campaign total',
    scheduleTitle: 'Payment schedule',
    scheduleTotal: 'Total {{amount}}',
    scheduleFullPayment: 'Full payment',
    scheduleFirstPayment: 'First payment · {{month}}',
    scheduleDueAtCheckout: 'Charged at checkout',
    scheduleAuthorisedAtCheckout: 'Authorised at checkout, charged once providers confirm',
    scheduleDueOn: 'Due {{date}}',
    schedulePaidOn: 'Paid {{date}}',
    scheduleProcessing: 'Processing - direct debits take a few days to clear',
    scheduleFailed: 'Payment failed',
    scheduleCancelled: 'Cancelled - won’t be charged',
    scheduleSplit: 'Production {{production}} · Campaign days {{ads}}',
    scheduleVatIncluded: 'All amounts include VAT.',
    paymentsTitle: 'Payments',
    paymentsPaidSoFar: 'Paid so far',
    paymentsRemaining: '{{amount}} still to pay',
    paymentsFailedNotice: 'A direct debit didn’t go through. Please check your bank account or contact us so your campaign isn’t interrupted.',
    paymentPlanTitle: 'How would you like to pay?',
    paymentPlanSubtitle: 'Choose before checkout. You can change it until you pay.',
    planTotalTitle: 'Pay in full',
    planTotalDesc: 'One payment for the whole campaign.',
    planMonthlyTitle: 'Pay monthly',
    planMonthlyDesc: 'Pay production costs and your first month now. Each following month is collected by direct debit on the 1st.',
    paymentPlanError: 'Could not update the payment plan.',
    checkoutAllInstant: 'All outdoors are instant booking: you’re charged at checkout and your campaign is confirmed straight away.',
    checkoutNeedsConfirmation: '{{count}} of {{total}} outdoors need their provider’s confirmation. At checkout your card is only authorised - you’re charged once providers confirm, and only for the outdoors they approve.',
    mandateStepTitle: 'Step 1 of 2 · Set up your direct debit',
    mandateStepDesc: 'Next, you’ll make your first payment by card.',
    confirmingTitle: 'Waiting for providers to confirm',
    confirmingDesc: 'Your card has been authorised, not charged. You’ll only be charged for the outdoors their providers approve.',
    awaitingDecisionTitle: 'Some outdoors aren’t available',
    awaitingDecisionDesc: 'Go ahead with the approved outdoors, or cancel the campaign and release your payment.',
    providersAnswerBy: 'Providers answer by {{date}}',
    decideBy: 'Decide by {{date}} - otherwise the campaign is cancelled and nothing is charged.',
    feedbackCount_approved: '{{count}} approved',
    feedbackCount_confirming: '{{count}} awaiting answer',
    feedbackCount_unavailable: '{{count}} unavailable',
    feedbackCount_expired: '{{count}} not answered in time',
    proceedWithApproved: 'Proceed with approved outdoors',
    proceedNoneApproved: 'No outdoor has been approved yet.',
    removeConfirmingHint: 'You can still remove outdoors that are awaiting an answer.',
    proceedModalTitle: 'Proceed with approved outdoors?',
    proceedOutdoorsLabel: 'Outdoors booked',
    proceedOutdoorsValue: '{{approved}} of {{total}}',
    proceedChargedLabel: 'You’ll be charged',
    proceedTotalMonthlyLabel: 'Campaign total',
    proceedModalNote: 'This amount is charged to your card now.',
    proceedModalMonthlyNote: 'Your first payment is collected now and the rest in installments, by direct debit.',
    proceedModalDropped: 'The other outdoors ({{count}}) will be removed from this campaign.',
    proceedSuccess: 'Your campaign is confirmed.',
    cancelDecisionTitle: 'Cancel this campaign?',
    cancelDecisionDesc: 'The authorised payment is released and nothing is charged. All outdoors are freed for other advertisers.',
    unavailableTitle: 'None of the outdoors were available',
    unavailableDesc: 'Their providers couldn’t confirm these dates, so nothing was charged. Try other dates or outdoors.',
    feedback_CONFIRMING: 'Awaiting provider',
    feedback_APPROVED: 'Approved',
    feedback_UNAVAILABLE: 'Unavailable',
    feedback_EXPIRED: 'Not answered',
    creativeThumbnailAlt: 'Creative of campaign {{name}}',
    title: 'Campaigns',
    newCampaign: 'New Campaign',
    newCampaignTooltip: 'Click to create a new campaign',
    mustRegisterAsAdvertiser: 'You must register as an Advertiser to be able to create Campaigns',
    noCampaigns: 'No campaigns yet',
    noCampaignsDesc: 'Create your first campaign to start advertising outdoors.',
    browseSpaces: 'Browse outdoor spaces',
    status: 'Status',
    from: 'From',
    to: 'To',
    filter: 'Filter',
    clearFilter: 'Clear filter',
    outdoorSlots: 'Outdoors',
    outdoorsColHeader: 'Outdoors',
    startDate: 'Start Date',
    endDate: 'End Date',
    paginationRange: 'Campaigns {{from}}-{{to}} of {{total}}',
    creatives: 'Creatives',
    payment: 'Payment',
    deleteTitle: 'Delete Campaign',
    deleteConfirm: 'Are you sure you want to delete this campaign? This cannot be undone.',
    uploadCreative: 'Upload creative',
    removeCreative: 'Remove',
    deletingCreative: 'Deleting creative…',
    creativeRatioMismatch: 'Image ratio does not match the required {{ratio}} format. Please upload an image with the correct proportions, or a PDF.',
    getPaymentDetails: 'Get payment details',
    requiredRatios: 'Required creative ratios',
    iban: 'IBAN',
    reference: 'Payment reference',
    viewCampaign: 'View',
    loading: 'Loading campaigns…',
    noSlots: 'No outdoor slots in this campaign.',
    noCreatives: 'No creatives uploaded yet.',
    subtitle: 'Manage your outdoor advertising campaigns',
    noFound: 'No campaigns found',
    noFoundDesc: 'Start by adding outdoors to your cart to create your first campaign.',
    browseOutdoors: 'Browse outdoors',
    outdoorsCount: '{{count}} outdoor',
    outdoorsCount_plural: '{{count}} outdoors',
    creativesCount: '{{count}} creatives',
    paymentLabel: 'Payment: {{status}}',
    backToCampaigns: 'Back to Campaigns',
    checklistTitle: 'Campaign Checklist',
    checklistOutdoors: 'Choose Outdoors for your Campaign',
    checklistCreatives: 'Add creatives',
    checklistTerms: 'Accept Terms & Conditions',
    checklistPay: 'Pay for Campaign',
    acceptTermsPrefix: 'I accept the',
    acceptTermsLink: 'Terms & Conditions',
    acceptTermsRequiredHint: 'You must accept the Terms & Conditions before paying for this campaign.',
    advertiserTermsModalTitle: 'Terms & Conditions for Advertisers & Campaigns',
    advertiserTermsModalHint: 'These are the sections of our Terms & Conditions that specifically apply to advertisers and campaigns.',
    viewFullTerms: 'View full Terms & Conditions',
    outdoorsHeader: 'Outdoors ({{count}})',
    noOutdoorsYet: 'No outdoors added yet.',
    requiredAspectRatios: 'Required aspect ratios',
    recResolution: 'recommended: {{w}}×{{h}} cm @ {{dpi}} dpi (1:{{scale}})',
    recInclBleed: 'incl. bleed',
    dimensionsCalculatorBleedNote: 'This outdoor has {{bleed}} cm of bleed on each edge, so sizes cover the full print area of {{w}} × {{h}} m (the visible area is {{trimW}} × {{trimH}} m).',
    orientationLandscape: 'Landscape',
    orientationPortrait: 'Portrait',
    dimensionsCalculatorTooltip: 'Calculate possible creative dimensions',
    dimensionsCalculatorTitle: 'Dimensions calculator for creative with ratio {{ratio}}',
    dimensionsCalculatorHint: 'Change the width or height (in centimetres) and the other side updates automatically to keep this ratio. We always design at 300 dpi, favouring a 1:10 scale of the outdoor\'s real size.',
    dimensionsCalculatorWidthLabel: 'Width (cm)',
    dimensionsCalculatorHeightLabel: 'Height (cm)',
    dimensionsCalculatorDpiLabel: 'Print resolution',
    dimensionsCalculatorScaleHint: 'Scale: 1:{{scale}} - we recommend 1:10 or a larger design (smaller scale number).',
    dimensionsCalculatorExportHint: 'Export your file at {{w}} × {{h}} px.',
    dimensionsCalculatorMinQualityWidth: 'Too small for good print quality - at least {{min}} cm needed for a 1:{{scale}} scale design.',
    dimensionsCalculatorMinQualityHeight: 'Too small for good print quality - at least {{min}} cm needed for a 1:{{scale}} scale design.',
    processingImage: 'Processing image...',
    noCreativesYet: 'No creatives uploaded yet',
    clickToUpload: 'Click to upload',
    creativesNote: 'These are the images that will be featured on the outdoor displays throughout your campaign.',
    creativeValid: 'Approved',
    creativeUnderReview: 'Under Review',
    creativeInvalid: 'Invalid',
    deleteCreativeTitle: 'Delete creative?',
    deleteCreativeBody: 'This creative has been approved or is under review. Deleting it will remove it from the campaign and require a new upload.',
    campaignInfo: 'Campaign Info',
    details: 'Details',
    requestPayment: 'Request Payment',
    paymentDetails: 'Payment Details',
    currency: 'Currency',
    bankTransferDetails: 'Bank transfer details',
    amount: 'Amount',
    importantRef: '⚠️ Important - Payment Reference',
    refNote: 'You must include this reference in your transfer description for it to be matched automatically.',
    deleteCampaign: 'Delete Campaign',
    deleteCampaignDesc: 'This will permanently delete this campaign and all associated data. This action cannot be undone.',
    addOutdoor: 'Add Outdoor',
    outdoorAdded: 'Outdoor added to campaign',
    selectOutdoor: 'Select an outdoor',
    outdoorDateConflict: 'This outdoor is already booked in this campaign for overlapping dates. Please choose different dates.',
    alreadyInCampaign: 'In campaign',
    name: 'Name',
    outdoorSubtotal: 'Subtotal',
    bankTransferNoticeTitle: 'Campaign Payment Required',
    bankTransferNotice: 'Your campaign will only be activated and all placements formally booked upon full payment confirmation. Click "Validate & Pay" to proceed. Please note: outdoor availability is re-validated at checkout - slots available when originally added to your campaign may no longer be guaranteed.',
    requestPaymentDisabledHint: 'All {{count}} required creatives must be uploaded and validated (status: Valid) before payment can be requested.',
    outdoorRemoved: 'Outdoor removed from campaign.',
    removeOutdoorConfirm: 'Are you sure you want to remove this outdoor from the campaign? This action cannot be undone.',
    qualityFail: 'Resolution too low - file not uploaded',
    qualityWarn: "Aspect ratio doesn't match - image may be cropped or padded",
    qualityAspectMismatch: 'Aspect ratio {{actual}} vs {{expected}} (outdoor)',
    qualityUploadAnyway: 'Upload anyway',
    qualityConfirmHint: 'Image may be cropped or padded to fit this format.',
    qualityDetailFail: 'This file is only sharp enough for {{achievedScale}} on a {{outdoorW}} × {{outdoorH}} m outdoor.',
    qualityTargetFail: 'Design your artwork at {{w}} × {{h}} cm (1:{{scale}} scale, {{dpi}} dpi) for this format.',
    recResolutionPx: 'recommended: {{w}}×{{h}}px @ {{dpi}} dpi',
    dimensionsCalculatorHintPx: "Change the width or height and the other side updates automatically to keep this ratio - the effective DPI updates too, so you can find alternative dimensions that still print at good quality.",
    dimensionsCalculatorWidthLabelPx: 'Width (px)',
    dimensionsCalculatorHeightLabelPx: 'Height (px)',
    dimensionsCalculatorDpiLabelPx: 'Effective DPI',
    dimensionsCalculatorMinDpiHintPx: 'Minimum {{dpi}} dpi required for this outdoor.',
    dimensionsCalculatorMinQualityWidthPx: 'Minimum quality width not yet reached (min. {{min}}px, recommended: {{rec}}px).',
    dimensionsCalculatorMinQualityHeightPx: 'Minimum quality height not yet reached (min. {{min}}px, recommended: {{rec}}px).',
    qualityWarnLowRes: 'Low resolution - image may print poorly',
    qualityConfirmHintLowRes: 'Image may print with visible quality loss.',
    qualityDetailWarnPx: '{{pixelW}} × {{pixelH}} px gives {{dpi}} DPI at full size.',
    qualityDetailFailPx: '{{pixelW}} × {{pixelH}} px gives {{dpi}} DPI at {{outdoorW}} × {{outdoorH}} m, below the {{minDpi}} DPI minimum.',
    qualityTargetWarnPx: 'We recommend at least {{recDpi}} DPI for this format: {{recW}} × {{recH}} px, or {{recScaleLabel}}.',
    qualityTargetFailPx: "You'll need at least {{minW}} × {{minH}} px - working at 1:{{scale}}, that's a {{canvasW}} × {{canvasH}} m canvas at {{designDpi}} DPI.",
    creativeUnitLabel: 'Size units',
    creativeUnitCm: 'Centimetres',
    creativeUnitPx: 'Pixels',
    creativeUnitHint: 'Choose how recommended creative sizes are shown and checked. Centimetres: design at a 1:10 scale of the outdoor, always at 300 dpi. Pixels: minimum resolution based on the outdoor\'s size.',
    previewBadge: 'Preview',
    previewOnlyHint: 'Preview only - download the original to print',
    downloadPrintFile: 'Download print file',
    downloadPrintFileHint: 'Full-resolution original',
    printFileExplainer: 'The image above is a lightweight preview. Download the original, full-resolution file to send to print.',
    previewFailed: 'We couldn\'t prepare a preview of this file in your browser. Please export it as JPG or PNG and try again.',
    creativeFileRequirements: 'Accepted files: TIF, TIFF, JPG, JPEG, PNG or PDF. Print requires CMYK colour mode. Images in other colour modes are converted to CMYK, with a preview for you to approve before upload. PDF files must already be in CMYK.',
    creativeFormatNotAllowed: '"{{name}}" isn\'t an accepted file type. Please upload a TIF, TIFF, JPG, JPEG, PNG or PDF file.',
    creativeNotCmykPdf: '"{{name}}" contains RGB colours (in the artwork or an embedded image). Print files must be entirely CMYK - export it again with a CMYK colour profile (e.g. PDF/X-1a) and upload it.',
    creativeUnreadable: 'We couldn\'t read "{{name}}". It may be damaged or saved in an unusual way - please export it again and retry.',
    cmykNoticeTitle: '"{{name}}" isn\'t in CMYK colour mode',
    cmykNoticeBody: 'Print requires CMYK. We can convert it for you using the standard profile for outdoor print, and you\'ll review a before-and-after preview before anything is uploaded.',
    cmykConvert: 'Convert to CMYK',
    cmykModalTitle: 'Convert to CMYK for print',
    cmykConverting: 'Converting to CMYK ({{profile}})…',
    cmykBefore: 'Original',
    cmykAfter: 'Print preview (CMYK)',
    cmykShiftWarning: 'Some vivid colours will look noticeably different in print (about {{percent}}% of the image). If exact colours matter, adjust the artwork in your design software before uploading.',
    cmykProfileNote: 'Converted with the {{profile}} profile, the standard for outdoor print. Screens can\'t show CMYK exactly, so the preview simulates the printed result.',
    cmykAccept: 'Accept converted CMYK version',
    cmykErrorUnavailable: 'CMYK conversion is temporarily unavailable. Please convert the file to CMYK in your design software and upload it again.',
    cmykErrorTooLarge: 'This image is too large to convert in the browser. Please convert it to CMYK in your design software and upload it again.',
    cmykErrorFailed: 'We couldn\'t convert this file. Please convert it to CMYK in your design software and upload it again.',
    pay: 'Validate & Pay',
    commission: 'Platform commission ({{rate}}%)',
    vatLabel: 'VAT',
    vatWithRate: 'VAT ({{rate}}%)',
    vatDetailsTitle: 'VAT details',
    vatDetailsBody: 'VAT is calculated according to the applicable tax treatment of each campaign component. Some amounts may include VAT, be subject to a different VAT rate, or fall outside the applicable VAT base.',
    totalWithoutVat: 'Total (without VAT)',
    grandTotal: 'Total',
    dailyRateRoundingNote: 'Daily rates are rounded to the nearest cent.',
    platformFeeNote: '* Outdoor daily rates already include a 5% platform fee.',
    confirmPayment: 'Confirm Payment',
    paymentSuccess: 'Payment successful! Your campaign will be activated shortly.',
    checkingPayment: 'Verifying your payment…',
    paymentConfirmed: 'Payment Confirmed!',
    paymentConfirmedDesc: 'Your payment has been confirmed. Your campaign will be activated shortly.',
    paymentPending: 'Payment Not Confirmed',
    paymentPendingDesc: 'Your payment could not be confirmed at this time. Please try again or contact support.',
    backToCampaign: 'Back to Campaign',
    expandPricing: 'Show pricing details',
    collapsePricing: 'Hide pricing details',
    availabilityUpdated: 'One or more outdoor slots were removed from your campaign - either they were reserved by another campaign for overlapping dates, or their minimum advance notice period had already elapsed. Please review the updated selection below.',
    availabilityDialogTitle: 'Confirm Availability & Proceed to Payment',
    availabilityDialogBody: 'Before proceeding, we will verify that all selected outdoors remain available. Some may have been reserved by other campaigns in the meantime. Please indicate how you would like us to handle any conflicts.',
    availabilityRemoveYes: 'Yes - automatically remove unavailable outdoors',
    availabilityRemoveYesDesc: 'Any outdoor no longer available will be removed from this campaign. You may review the updated selection before submitting payment.',
    availabilityRemoveNo: 'No - flag conflicts and let me review',
    availabilityRemoveNoDesc: 'Conflicting outdoors will be highlighted so you can adjust their dates or remove them manually before proceeding.',
    availabilityDialogConfirm: 'Proceed to Payment',
    outdoorFlaggedTitle: 'Dates no longer available',
    outdoorFlaggedDesc: 'This outdoor has been reserved by another campaign for overlapping dates. Please edit the dates or remove it to proceed to payment.',
    outdatedOutdoorsTitle: 'Campaign cannot proceed - outdated placements detected',
    outdatedOutdoorsDesc: 'One or more campaign outdoors have a scheduled start date that has already passed. Payment has not been processed. Please review the highlighted placements below and update their start dates before retrying.',
    outdoorOutdatedTitle: 'Start date in the past',
    outdoorOutdatedDesc: 'The scheduled start date for this placement has already passed. Please update it to a future date to continue.',
    pastStartDatesToast: 'Campaign times cannot be in the past.',
    cancelCampaign: 'Cancel Campaign',
    cancelCampaignConfirm: 'This will permanently cancel your campaign. Are you sure?',
    cancelCampaignYes: 'Yes, cancel it',
    cancelCampaignAbort: 'Keep campaign',
    cancelledSuccess: 'Campaign has been cancelled.',
    cancellationPolicyPending: 'Free cancellation - no charges apply while your campaign is in Pending status.',
    cancellationPolicyReady: 'Free cancellation if all outdoors are cancelled with more days\' notice than their Placement Provider\'s minimum notice period. A cancellation fee applies if one or more outdoors fall within their minimum notice period (plus VAT for Portuguese companies). Production costs (printing, setup, etc.) are non-refundable for any outdoor within its minimum notice period.',
    cancellationPolicyRunning: 'Please note: cancelling a campaign that is already running results in the forfeiture of 100% of the campaign value. No refund will be issued.',
    ppInvoices: 'Invoices from Placement Providers',
    outdoorAdj0: 'amazing',
    outdoorAdj1: 'great',
    outdoorAdj2: 'magnificent',
    outdoorAdj3: 'fabulous',
    outdoorAdj4: 'outstanding',
    outdoorsCollapsedSummary: 'Here we have {{count}} {{adj}} outdoors!',
    messages: 'Messages',
    noMessages: 'No placement providers have sent any messages regarding this campaign yet. Once they do, their conversations will appear here.',
    noMessagesYet: 'No messages in this conversation yet.',
    typeMessage: 'Type a message…',
    instructions: 'Instructions for Placement Providers',
    instructionsPlaceholder: 'e.g. Please display this campaign from 8am to 10pm only.',
    instructionsEmpty: 'No instructions added yet. Click Edit to add guidance for placement providers.',
    instructionsSaved: 'Instructions saved.',
    proofOfDisplay: 'Proof of Display',
    proofPending: 'Proof coming soon',
    proofPendingDesc: 'Your placement provider will upload proof of display shortly.',
    proofAlt: 'Proof of display – {{name}}',
    additionalFiles: 'Additional Files',
    additionalFilesSubtitle: 'Supporting materials for this campaign - not mandatory.',
    additionalFilesSubtitlePP: 'Supporting materials shared by the advertiser.',
    noAdditionalFiles: 'No additional files uploaded yet.',
    uploadFile: 'Upload file',
    fileUploaded: 'File uploaded successfully.',
    fileDeleted: 'File removed.',
    deleteFile: 'Delete file',
    addOutdoors: 'Add Outdoors',
    creativesLockedTitle: 'No outdoors added yet',
    creativesLockedDesc: 'Creatives must match each outdoor\'s required resolution. Add at least one outdoor to unlock uploads.',
    editDates: 'Edit dates',
    updateDates: 'Update dates',
    datesUpdated: 'Dates updated successfully',
  },
  dashboard: {
    title: 'Dashboard',
    earnings: 'Earnings',
    spendings: 'Spendings',
    last30: 'Last 30 days',
    last90: 'Last 90 days',
    thisYear: 'This year',
    accessRequests: 'Access Requests',
    noRequests: 'No pending requests',
    approve: 'Approve',
    reject: 'Reject',
    teamInvite: 'Invite Team Member',
    inviteEmail: 'Email address',
    sendInvite: 'Send Invite',
    totalEarned: 'Total earned',
    totalSpent: 'Total spent',
    activeOutdoors: 'Active outdoors',
    activeCampaigns: 'Active campaigns',
    overview: 'Overview',
    howPaidTitle: 'How you get paid',
    howPaidDesc: 'Once a campaign goes live, upload photo proofs for each billboard. When all proofs are verified, your payment is released automatically. Your payout is calculated at your listed daily rate multiplied by the number of active campaign days, net of a 5% platform service fee applied per booking.',
    ppOverview: 'Placement Provider overview',
    advertiserOverview: 'Advertiser overview',
    findOutdoors: 'Find Outdoors',
    addOutdoor: 'Add Outdoor',
    viewCampaigns: 'View Campaigns',
    manageOutdoors: 'Manage Outdoors',
    companyDetails: 'Company Details',
    userDetails: 'User Details',
    pendingRequests: 'Pending Access Requests ({{count}})',
    inviteDesc: "They'll receive an email with a link to join your company on Scapow.",
    invitePlaceholder: 'colleague@company.com',
    invoicesTitle: 'Invoices',
    downloadInvoice: 'Download',
    invoiceIssued: 'Issued',
    invoicePaid: 'Paid',
    invoiceUnknownCampaign: 'Unknown campaign',
    invoicesSubtitle: 'Your payment history and downloadable invoice documents.',
    invoicesEmpty: 'Looking forward to populating this section for you!',
  },
  invoices: {
    title: 'Invoices',
    subtitleAdvertiser: 'Scapow and placement provider invoices across all your campaigns.',
    subtitlePP: 'Your payment history and downloadable invoice documents.',
    issued: 'Issued',
    download: 'Download',
    empty: 'No invoices yet. They will appear here once your campaigns are processed.',
    unknownCampaign: 'Unknown campaign',
    ppInvoices: 'Placement Provider Invoices ({{count}})',
    unknownProvider: 'Unknown provider',
    notAvailable: 'Not available',
    typeInvoice: 'Invoice',
    typeCreditNote: 'Credit Note',
  },
  payments: {
    title: 'Payments',
    subtitle: 'Your payment history for campaigns run on your outdoors.',
    empty: 'No payments yet. They will appear here once campaigns are paid out.',
    unknownCampaign: 'Unknown campaign',
    columnId: 'Payment ID',
    columnCampaign: 'Campaign',
    columnValue: 'Value',
    columnPaidAt: 'Paid At',
    columnStatus: 'Status',
    statusPaid: 'Paid',
    statusTransferRequested: 'Transfer Requested',
  },
  userDetails: {
    receiveEmails: 'Receive emails',
    receiveEmailsOnDesc: 'Platform emails are sent to {{email}}.',
    receiveEmailsOffDesc: 'You won’t receive platform emails. Turn this on to get them again.',
    emailsTurnedOn: 'You’ll receive platform emails.',
    emailsTurnedOff: 'You won’t receive platform emails anymore.',
    emailsUpdateError: 'Could not update your email preference.',
    title: 'Account Details',
    subtitle: 'Manage your personal account information.',
    name: 'Name',
    editName: 'Click to edit',
    email: 'Email',
    memberSince: 'Member since (UTC)',
    accountStatus: 'Account status',
    statusVerified: 'Verified',
    statusPending: 'Pending verification',
    nameUpdated: 'Name updated successfully.',
    nameRequired: 'Please enter a valid name (at least 2 characters).',
    password: 'Password',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    passwordUpdated: 'Password updated successfully.',
    passwordFieldsRequired: 'Please fill in all password fields.',
    passwordTooShort: 'New password must be at least 8 characters.',
    passwordSameAsCurrent: 'New password must be different from your current password.',
    passwordMismatch: 'New password and confirmation do not match.',
  },
  admin: {
    tabUnpaidInstallments: 'Unpaid Installments',
    unpaidInstallmentsIntro: 'Installments still unpaid 6 days after their due date, oldest first.',
    noUnpaidInstallments: 'No unpaid installments.',
    installmentOf: 'Installment {{number}} of {{total}}',
    installmentNumber: 'Installment {{number}}',
    installmentDue: 'Due {{date}}',
    installmentOverdueDays_one: '{{count}} day overdue',
    installmentOverdueDays_other: '{{count}} days overdue',
    proofOfCompany: 'Proof of company',
    openProofOfCompany: 'Open {{name}} in a new tab',
    noProofOfCompany: 'No proof of company uploaded',
    proofLocationLoading: 'Finding address…',
    proofLocationViewMap: 'View on map',
    title: 'Admin Panel',
    verifications: 'Verifications',
    advertisers: 'Advertisers',
    providers: 'Providers',
    payments: 'Payments',
    noVerifications: 'No pending verifications',
    noPayments: 'No pending payments',
    markAsDone: 'Mark as done',
    business: 'Business',
    type: 'Type',
    status: 'Status',
    actions: 'Actions',
    approve: 'Approve',
    reject: 'Reject',
    subtitle: 'Platform management & moderation',
    proofVerification: 'Manual Verifications',
    accessRequestsTab: 'Access Requests',
    noAccessRequests: 'No pending access requests.',
    noAdvertisers: 'No advertisers found.',
    noProviders: 'No providers found.',
    noPaymentsStatus: 'No payments with this status.',
    campaignOutdoor: 'Campaign outdoor: {{id}}',
    campaignFrom: 'Campaign from {{date}}',
    adCreative: 'Ad creative',
    proofPhotos: 'Proof photos ({{count}}) - click to open full size',
    period: 'Period',
    outdoorsLabel: 'outdoors',
    campaignsLabel: 'campaigns',
    spentLabel: 'spent',
    earnedLabel: 'earned',
    markAsPaid: 'Mark as Paid',
    tabAds: 'Ads',
    tabBusinessProofs: 'Business Proofs',
    tabProofOfAds: 'Proof of Ads',
    approved: 'Approved',
    rejected: 'Rejected',
    noAds: 'No pending ad verifications.',
    noBusinessProofs: 'No pending business proof verifications.',
    noProofOfAds: 'No pending proof-of-ad verifications.',
    refundsTab: 'Refunds & Debts',
    refundsSearchPlaceholder: 'Search by campaign or advertiser name…',
    refundsNoCampaigns: 'No campaigns found.',
    refundsSelectOutdoors: 'Select outdoors to refund',
    refundsSelectAll: 'Select all',
    refundsDeselectAll: 'Deselect all',
    refundsNoEligible: 'No eligible outdoors found for this campaign.',
    refundsEligibleNote: 'Only non-rejected outdoors are eligible for refund.',
    refundsSubmit: 'Process Refund',
    refundsSuccess: 'Refund processed successfully.',
    refundsSubTabRefunds: 'Advertiser Refunds',
    refundsSubTabDebts: 'Provider Debts',
    refundTypeTotal: 'Total',
    refundTypePartial: 'Partial',
    refundDaysLabel: 'Days to refund',
    refundDaysHint: 'Max {{max}} days',
    debtNoDebts: 'No outstanding provider debts.',
    debtSettle: 'Settle',
    debtSettleAmount: 'Settlement amount',
    debtSettleDoc: 'Settlement document',
    debtSettleDocHint: 'Upload the signed settlement document (PDF, image, etc.)',
    debtSettleConfirm: 'Upload & Settle',
    debtSettleSuccess: 'Debt settled and document uploaded successfully.',
    debtStatusOutstanding: 'Outstanding',
    debtStatusSettled: 'Settled',
    debtCampaign: 'Campaign',
    campaignsTab: 'Campaigns',
    noCampaigns: 'No campaigns found.',
    accessRequestFor: 'Requesting access to: {{entity}}',
    tabByStatus: 'By Status',
    tabTransferRequested: 'Transfer Requested',
    checkPayment: 'Check',
    lastCheckedAt: 'Last checked',
    neverChecked: 'Never checked',
    noTransferRequested: 'No transfer-requested payments found.',
    checkSuccess: 'Payment check initiated.',
    revenueTitle: 'Revenue',
    revenueSubtitle: 'Platform commission & VAT by billing period',
    revenueGross: 'Gross Revenue',
    revenueCommission: 'Commission',
    revenueVat: 'VAT',
    revenueStripeFees: 'Stripe Fees',
    revenueNet: 'Net Revenue',
    revenueEmpty: 'No revenue recorded for this period.',
    revenueMonth: 'Month',
    revenueYear: 'Year',
    revenueDailyTitle: 'Daily Breakdown',
    revenueNoDaily: 'No daily data for this period.',
    searchByName: 'Search by name…',
    importOutdoorsFromFile: 'Import Outdoors from File',
    chooseFile: 'Choose file…',
    csvSend: 'Send',
    importOutdoorsSuccess: 'Outdoors file successfully sent.',
    remainingFreeCommissions: 'Free commissions left: {{count}}',
    setFreeCommissions: 'Set new remaining free commissions',
    freeCommissionsUpdated: 'Remaining free commissions updated.',
    freeCommissionsUpdateFailed: 'Could not update the remaining free commissions.',
    verified: 'Verified',
  },
  ppCampaigns: {
    searchAllStatuses: 'Showing campaigns in every status. Clear the search to filter by status.',
    typeAll: 'All',
    typeScapow: 'Scapow',
    typeOffline: 'Offline',
    typeFilterLabel: 'Campaign type',
    noOfflineResults: 'No offline campaigns here yet. Add outdoors to one from your Outdoors page.',
    goToOutdoors: 'Go to Outdoors',
    offlineBadge: 'Offline',
    moreOutdoors: '+{{count}} more',
    offlineNotes: 'Notes',
    payoutCommission: 'Platform commission',
    payoutCommissionVat: 'VAT on platform commission',
    payoutTransferred: 'Transferred',
    payoutValueWithoutVat: 'Ad value (excl. VAT)',
    payoutVat: 'VAT',
    payoutProduction: 'Production costs (VAT incl.)',
    payoutsTitle: 'Payouts',
    payoutsCount: 'Payouts: {{count}}',
    payoutsReceived: 'Received so far',
    payoutFull: 'Full payout',
    payoutFirst: 'First payout · {{month}}',
    payoutAfterProof: 'Expected from {{date}}, after proof of display is approved',
    payoutExpectedOn: 'Expected {{date}}',
    payoutReceivedOn: 'Received {{date}}',
    payoutProcessing: 'Transfer in progress',
    payoutOnHold: 'On hold - the advertiser’s direct debit failed',
    payoutsOnHoldNotice: 'A payout is on hold because the advertiser’s direct debit failed. It’s released as soon as that payment succeeds.',
    payoutsNetNote: 'Amounts are net of the Scapow commission and its VAT, before any outstanding debt.',
    colProduction: 'Production',
    title: 'Campaigns',
    subtitle: 'Monitor and manage campaigns that include your outdoor placements.',
    tabPending: 'Pending',
    tabReady: 'Ready',
    tabRunning: 'Running',
    tabCompleted: 'Completed',
    noResults: 'No campaigns found for this status.',
    outdoorSlots: '{{count}} outdoor slot',
    outdoorSlots_plural: '{{count}} outdoor slots',
    instructions: 'Advertiser instructions',
    backToCampaigns: 'Back to Campaigns',
    yourSlots: 'Your Outdoor Slots',
    noSlots: 'No outdoor slots from your placements found in this campaign.',
    advertiserInstructions: "Advertiser's Instructions",
    messagesWithAdvertiser: 'Messages with Advertiser',
    noConversation: 'No messages yet. Start a conversation with the advertiser by typing below.',
    myInvoice: 'My Invoice to Advertiser',
    uploadInvoice: 'Upload Invoice',
    replaceInvoice: 'Replace Invoice',
    uploadInvoiceSuccess: 'Invoice uploaded successfully.',
    invoiceUploaded: 'View invoice',
    noInvoiceYet: 'No invoice uploaded yet.',
    creativesAndOutdoors: 'Creatives & Your Outdoors',
    noCreativeForRatio: 'No creative uploaded for this format yet.',
    yourOutdoorsForFormat: 'Your outdoors for this format',
    viewOutdoor: 'View outdoor',
    goToCampaign: 'Go to campaign page',
    yourEarnings: 'Your earnings',
    readyPaymentTitle: 'Display Verification Required',
    readyPaymentNoteReady: 'Your earnings are secured pending campaign launch. Once this campaign goes live, upload proof of display setup for each outdoor to initiate payment release.',
    readyPaymentNote: 'To release your earnings, upload proof of setup for each outdoor via the Verify Displays step.',
    readyPaymentCta: 'Go to Verify Displays',
    paymentPaidTitle: 'Payment Received',
    paymentPaidDesc: 'Your earnings for this campaign have been paid out.',
    viewBreakdown: 'view breakdown',
    earningsBreakdown: 'Earnings breakdown',
    colDays: 'Days',
    colNetDailyValue: 'Daily Value + VAT',
    colEarnings: 'Revenue',
  },
  upcomingCampaigns: {
    title: 'Upcoming Campaigns',
    subtitle: 'Campaigns ready to run that include your outdoor placements.',
    noResults: 'No upcoming campaigns found.',
  },
  getPaid: {
    title: 'Get Paid',
    subtitle: 'Follow the steps below to verify your displays and receive payment.',
    step1: { label: 'Upcoming Campaigns', desc: 'Get the Creatives to setup the Outdoors' },
    step2: { label: 'Verify Displays', desc: 'Upload proof of Ad to get paid' },
    step3: { label: 'Paid Invoices', desc: 'Your payment history' },
    paidOn: 'Paid on',
    downloadInvoice: 'Invoice',
    noPayments: 'No payments yet',
    noPaymentsDesc: 'Complete the verification step to unlock payment.',
    upcomingEmpty: 'No upcoming campaigns at the moment. Check back later.',
    goToVerify: 'Go to Verify Displays',
    goToPaid: 'View Payments',
    goToUpcoming: 'View Upcoming Campaigns',
  },
  cart: {
    title: 'Your Cart',
    empty: 'Your cart is empty',
    emptyDesc:
      'Search for outdoor spaces and add them to your cart to create a campaign.',
    browseOutdoors: 'Browse Outdoors',
    campaignDetails: 'Campaign Details',
    campaignName: 'Campaign name',
    description: 'Description (optional)',
    subtotal: 'Subtotal',
    total: 'Total',
    remove: 'Remove',
    placeOrder: 'Create Campaign',
    creating: 'Creating…',
    estimatedCost: 'Estimated cost',
    signInTitle: 'Sign in to continue',
    signInDesc: 'Create an account or sign in to build your campaign.',
    buildCampaign: 'Build Campaign',
    estimatedTotal: 'Estimated total',
    campaignNamePlaceholder: 'Summer 2026 Campaign',
    detailsPlaceholder: 'Any notes...',
    campaignLabel: 'Campaign {{n}}',
    selectCampaign: 'Add to campaign:',
    signInToCheckout: 'Sign in to create this campaign',
    advertiserRequired: 'You need an Advertiser account to create campaigns',
    instructions: 'Instructions for Placement Providers (optional)',
    instructionsPlaceholder: 'Any special instructions for Placement Providers should go here...',
    instructionsHint: 'You can also update this after the campaign is created.',
  },
  invitations: {
    title: 'User Invitations',
    subtitle: 'Manage team member invitations for your business',
    pendingTitle: 'Pending Invitations',
    noPending: 'No pending invitations',
    noPendingDesc: 'Invite a team member above to get started.',
    sentAt: 'Sent',
    cancel: 'Cancel',
    inviteSuccess: 'Invitation sent successfully.',
    inviteError: 'Failed to send invitation.',
    cancelSuccess: 'Invitation cancelled.',
    formTitle: 'Invite Team Member',
    formDesc: "They'll receive an email with a link to join your company on Scapow.",
    formPlaceholder: 'colleague@company.com',
    formSend: 'Send Invite',
  },
  team: {
    title: 'Team Management',
    subtitle: 'Manage your team members and send invitations',
    tabUsers: 'Active Members',
    tabInvitations: 'Invitations',
    noUsers: 'No active members yet',
    noUsersDesc: 'Users will appear here once they accept an invitation',
    statusVerified: 'Verified',
    statusPending: 'Pending',
  },
  terms: {
    back: 'Back',
    title: 'Terms and Conditions',
    effectiveDate: 'Effective date: 19th June 2026 · SCAPOW · Codify, Unipessoal Lda',
    introBanner: 'By registering an account, accessing, or using the Platform, you agree to be legally bound by these Terms. If you do not agree, you must not use the Platform.',
    footerNote: 'SCAPOW · Codify, Unipessoal Lda · Effective 19th June 2026',
    s1: 'Introduction',
    s1_p1: 'These Terms and Conditions ("Terms") govern the access to and use of the SCAPOW platform ("Platform"), operated by Codify, Unipessoal Lda ("Company", "we", "our", "us").',
    s1_p2: 'The Platform functions as a digital marketplace connecting:',
    s1_i1Bold: 'Advertisers',
    s1_i1Rest: ', who seek to purchase advertising space for marketing campaigns; and',
    s1_i2Bold: 'Placement Providers',
    s1_i2Rest: ', who own, operate, or control physical advertising spaces, including but not limited to billboards, outdoor signs, digital displays, and other media placements.',
    s2: 'Eligibility',
    s2_p1: 'Users must:',
    s2_i1: 'Be at least 18 years old;',
    s2_i2: 'Have legal capacity to enter into binding agreements;',
    s2_i3: 'Provide accurate and complete information during registration;',
    s2_i4: 'Comply with all applicable laws and regulations.',
    s2_p2: 'Business users represent that they are authorized to bind their company or organization.',
    s3: 'User Roles',
    s3_1: '3.1 Advertisers',
    s3_1_p1: 'Advertisers may:',
    s3_1_i1: 'Search, select, and purchase advertising placements;',
    s3_1_i2: 'Upload advertising materials;',
    s3_1_i3: 'Launch and manage campaigns.',
    s3_1_p2: 'Advertisers are solely responsible for:',
    s3_1_i4: 'The legality of their advertising content;',
    s3_1_i5: 'Ownership or authorization of all intellectual property used;',
    s3_1_i6: 'Compliance with advertising laws.',
    s3_2: '3.2 Placement Providers',
    s3_2_p1: 'Placement Providers may:',
    s3_2_i1: 'List available advertising spaces;',
    s3_2_i2: 'Set pricing, campaign availability, and operational requirements;',
    s3_2_i3: 'Accept campaign placements.',
    s3_2_p2: 'Placement Providers represent and warrant that they:',
    s3_2_i4: 'Own or lawfully control the advertising space;',
    s3_2_i5: 'Have all permits, licenses, and rights necessary for commercial advertising use;',
    s3_2_i6: 'Can fulfill booked campaigns within agreed timelines.',
    s3_3: '3.3 Legal Declaration for Listing Advertising Spaces',
    s3_3_p1: 'When listing an outdoor advertising space on the Platform, each Placement Provider must expressly confirm, at the time of submission, that:',
    s3_3_i1: 'They hold legal rights over the submitted advertising space;',
    s3_3_i2: 'They are authorized to offer it for commercial use;',
    s3_3_i3: 'The listing complies with all applicable laws, permits, licenses, zoning regulations, and local authority requirements.',
    s3_3_p2: 'This declaration is a condition of listing. Submissions made without this confirmation will not be accepted. The Platform reserves the right to remove any listing where the declaration is found to be false or misleading, and to suspend or terminate the account of any Placement Provider who provides inaccurate information.',
    s4: 'Platform Role',
    s4_p1: 'The Platform acts solely as an intermediary and facilitator. The Company:',
    s4_i1: 'Does not own advertising spaces;',
    s4_i2: 'Does not act as advertiser or placement provider;',
    s4_i3: 'Does not guarantee campaign performance, impressions, or business results;',
    s4_i4: 'Is not responsible for the physical installation or removal of advertisements.',
    s4_p2: 'Each transaction forms a direct contractual relationship between the Advertiser and Placement Provider.',
    s5: 'Campaign Bookings',
    s5_p1: 'A campaign booking becomes binding once:',
    s5_i1: 'The Advertiser has completed checkout - paying in full or, for a campaign paid in installments, authorising its first payment and the direct debit for the following installments;',
    s5_i2: 'Each outdoor placement is confirmed - immediately for instant-booking placements, or by its Placement Provider within the confirmation period;',
    s5_i3: 'The campaign start date is scheduled.',
    s5_p2: 'All bookings are subject to the minimum operational notice period specified by the Placement Provider. The minimum notice period determines the latest moment an Advertiser may submit and pay for a campaign. Failure to meet this notice period may result in rejection or rescheduling.',
    s6: 'Payment Terms',
    s6_1: '6.1 Advertiser Payments',
    s6_1_p1: 'Advertisers pay according to the payment plan selected at checkout:',
    s6_1_i1: 'Pay in full - the full campaign amount is charged at checkout;',
    s6_1_i2: 'Monthly or every three months - the production costs and the first billing period are charged at checkout, and each following billing period is collected by direct debit on its first day. These plans are available only where the campaign extends beyond its first billing period.',
    s6_1_p2: 'Checkout must be completed before the campaign start date and before the Placement Provider\'s minimum notice period expires. Where outdoor placements require confirmation, the payment is only authorised at checkout and is charged once they are confirmed, and solely for the confirmed placements. Late payment of any installment is governed by section 6.4. If checkout is not completed in time:',
    s6_1_i3: 'The booking may be automatically cancelled;',
    s6_1_i4: 'The Placement Provider has no obligation to reserve the advertising space.',
    s6_2: '6.2 Platform Fees',
    s6_2_p1: 'The Platform may charge service fees, commissions, or transaction fees. Such fees will be disclosed before purchase. Platform fees are non-refundable unless required by law.',
    s6_3: '6.3 Placement Provider Payouts',
    s6_3_p1: 'Placement Providers become eligible for payment only after:',
    s6_3_i1: 'The advertising materials have been fully installed;',
    s6_3_i2: 'Proof of installation has been uploaded through the Platform;',
    s6_3_i3: 'Such proof is approved or not disputed within the applicable review period.',
    s6_3_p2: 'Proof must include clear photographic evidence showing the campaign correctly displayed. The Platform reserves the right to verify authenticity. Payments may be delayed, withheld, or reversed in cases of fraud, dispute, or non-performance.',
    s6_4: '6.4 Payment Obligations and Late Payment',
    s6_4_p1: 'Each confirmed booking constitutes a binding payment obligation of the Advertiser. The Advertiser shall pay, in full and when due, all amounts for the campaigns and outdoor placements it has booked, including each installment of a campaign paid in installments (monthly or every three months).',
    s6_4_i1: 'Any amount not paid by its due date - including a direct debit that is rejected, returned or reversed - shall be overdue from that date. The Platform will notify the Advertiser and may attempt the collection again.',
    s6_4_i2: 'Where any amount relating to a campaign remains overdue for more than two (2) months from its due date, the Placement Provider may, without liability towards the Advertiser, remove the Advertiser\'s creatives from the affected outdoor placements and make those placements available to other advertisers.',
    s6_4_i3: 'Such removal shall not release the Advertiser from its obligations: all amounts already due, together with any fees applicable under section 9.3, shall remain payable in full.',
    s6_4_i4: 'The Platform and/or the Placement Provider may take legal action to recover any outstanding amounts, together with late-payment interest at the applicable statutory rate and reasonable recovery and legal costs, to the extent permitted by applicable law.',
    s6_4_i5: 'The Platform may also suspend the Advertiser\'s account and decline new bookings until all overdue amounts have been settled, in accordance with section 15.',
    s6_4_p2: 'The removal of creatives under this section shall not constitute non-performance by the Placement Provider under sections 9.4 and 9.5 and shall give rise to no refund.',
    s7: 'Campaign Materials',
    s7_p1: 'Advertisers must submit campaign materials within the required deadline. Materials must:',
    s7_i1: 'Meet technical specifications;',
    s7_i2: 'Be printable and usable;',
    s7_i3: 'Comply with applicable laws;',
    s7_i4: 'Not contain illegal, defamatory, offensive, or infringing content.',
    s7_p2: 'Placement Providers may reject materials that do not comply. The Platform may remove content at its sole discretion.',
    s8: 'Proof of Placement',
    s8_p1: 'Placement Providers must upload proof of installation promptly after installation. Failure to provide proof may result in:',
    s8_i1: 'Delayed payment;',
    s8_i2: 'Cancellation of payout;',
    s8_i3: 'Suspension from the Platform.',
    s8_p2: 'Advertisers may dispute proof within the applicable dispute window after upload. If no dispute is submitted within this period, proof shall be deemed accepted.',
    s9: 'Cancellations and Refunds',
    s9_1: '9.1 Advertiser Cancellation',
    s9_1_p1: 'If an Advertiser cancels:',
    s9_1_i1: "Before the Placement Provider's minimum notice period: eligible for refund, less applicable fees;",
    s9_1_i2: 'After the notice period begins: refund may be denied.',
    s9_1_p2: 'Production, printing, and preparation costs may be non-refundable.',
    s9_2: '9.2 Placement Provider Cancellation',
    s9_2_p1: 'If a Placement Provider cancels a confirmed booking without valid reason:',
    s9_2_i1: 'The Advertiser shall receive a full refund;',
    s9_2_i2: 'The Placement Provider may incur penalties, reduced visibility, suspension, or account termination.',
    s9_3: '9.3 Campaign Cancellation Policy',
    s9_3_i1: 'Campaigns in Pending status may be cancelled free of charge at any time prior to payment.',
    s9_3_i5: 'Where the cancellation date is more days before the start date of each outdoor activation than the respective Placement Provider\'s minimum notice period, no cancellation fee shall apply and the Advertiser shall receive a full refund of all amounts paid.',
    s9_3_i2: 'Once payment has been processed, a cancellation fee of 30% of the total campaign value applies where one or more of the campaign\'s outdoor activations fall within the minimum notice period given by the respective Placement Provider.',
    s9_3_i3: 'For companies registered in Portugal, the applicable VAT rate will be applied to the cancellation fee.',
    s9_3_i4: 'Where one or more outdoor activations fall within the minimum notice period given by the Placement Provider, setup and print costs are non-refundable.',
    s9_3_i6: 'Cancellation of a campaign that is already running will result in the forfeiture of 100% of the campaign value. No refund will be issued.',
    s9_3_i7: 'Where the 30% cancellation fee applies, 20% of the total campaign value will be transferred to the respective placement providers, net of the standard 5% platform commission and applicable VAT.',
    s9_4: '9.4 Refund for Unproven Placements',
    s9_4_p1: 'In the event that a Placement Provider fails to submit valid proof of display for one or more outdoor placements within the required timeframe, Scapow will issue a refund to the Advertiser as follows:',
    s9_4_i1: "For each day within the campaign period that a placement fails to display the Advertiser's creative, the proportional daily value for that outdoor placement will be refunded to the Advertiser.",
    s9_4_i4: 'A cancellation fee of 10% will be applied to the total amount refunded for failing days, plus applicable VAT.',
    s9_4_i2: 'Refunds will be processed within a reasonable timeframe following confirmation that proof of display has not been provided or has been deemed invalid.',
    s9_4_i3: 'Platform service fees applicable to proven and fulfilled placements remain non-refundable.',
    s9_5: '9.5 Placement Provider Non-Performance - Partial Campaign Fulfilment',
    s9_5_p1: 'Should a Placement Provider fail to display the Advertiser\'s campaign materials for the full duration of the agreed campaign period, each day for which the agreed display obligation is not met shall constitute a "Non-Compliant Day".',
    s9_5_a: 'a) Financial Liability to Scapow',
    s9_5_p2: 'In respect of each Non-Compliant Day, the Placement Provider shall be liable to the Platform for an amount equivalent to the daily advertising value rate applicable to the relevant campaign slot (the "Non-Performance Amount"). Recovery of the Non-Performance Amount shall be effected at the Platform\'s sole discretion by one or more of the following means:',
    s9_5_i1: '(i) requiring the Placement Provider to remit the Non-Performance Amount directly to the Platform within the period specified in a written notice issued by the Platform; or',
    s9_5_i2: '(ii) deducting the Non-Performance Amount from any present or future campaign payouts otherwise due to the Placement Provider, whether under the same campaign or any subsequent engagement on the Platform.',
    s9_5_p3: 'The Platform reserves the right to apply both remedies concurrently to the extent necessary to recover the total Non-Performance Amount in full.',
    s9_5_b: 'b) Full Restitution to the Advertiser',
    s9_5_p4: 'In respect of each Non-Compliant Day, the Advertiser shall be entitled to a full reimbursement of all amounts paid for such days, including the corresponding daily campaign rate, any applicable Platform commissions, and any service or transaction fees attributable to those days. Such reimbursement shall be processed by the Platform within a reasonable period following confirmed determination of non-compliance.',
    s9_5_c: 'c) Determination of Non-Compliance',
    s9_5_p5: 'Non-compliance with the agreed display period shall be assessed on the basis of evidence submitted through the Platform, including but not limited to proof-of-placement records, Advertiser reports, photographic documentation, and any other material the Platform considers relevant. The Platform\'s determination shall be final and binding for the purposes of calculating the Non-Performance Amount and administering Advertiser reimbursements, without prejudice to the legal rights of either party under applicable law.',
    s9_6: '9.6 Force Majeure - Natural Disasters',
    s9_6_p1: 'A "Force Majeure Event" is a natural disaster or related emergency beyond the reasonable control of the Advertiser and the Placement Provider that physically prevents an outdoor placement from displaying the Advertiser\'s creative, or makes doing so unsafe - including earthquakes, floods, storms, hurricanes, wildfires, landslides, evacuation or emergency orders issued by the competent authorities, and power outages caused by such events. Ordinary adverse weather, normal wear and tear and lack of maintenance are not Force Majeure Events.',
    s9_6_a: 'a) Notification and Evidence',
    s9_6_p2: 'The Placement Provider must report a Force Majeure Event through the Platform within 48 hours of becoming aware of it, together with supporting evidence (such as photographs or official alerts) and an estimated restoration date. The Platform shall assess, on the basis of that evidence, whether the event qualifies; its determination shall be final and binding for the purposes of this section.',
    s9_6_b: 'b) Effect on the Placement Provider',
    s9_6_i1: 'Each day on which display is prevented by a qualifying Force Majeure Event (a "Force Majeure Day") shall not constitute a Non-Compliant Day under section 9.5, and no Non-Performance Amount shall be due in respect of it.',
    s9_6_i2: 'No payout shall be owed to the Placement Provider for Force Majeure Days.',
    s9_6_i3: 'The Placement Provider must restore the display within 5 business days after the Force Majeure Event ends. Any day beyond that period on which the display is not restored shall constitute a Non-Compliant Day under section 9.5.',
    s9_6_i4: 'The Placement Provider remains responsible for the maintenance and adequate insurance of its structures, including the cost of reprinting and reinstalling any creative materials damaged or destroyed by the event.',
    s9_6_c: 'c) Effect on the Advertiser',
    s9_6_i5: 'The Advertiser shall be entitled to a full refund of all amounts paid for Force Majeure Days, including the daily campaign rate, the corresponding Platform commission and applicable VAT, without the 10% fee referred to in section 9.4.',
    s9_6_i6: 'Alternatively, the Advertiser may choose to move the affected days to the end of the campaign, subject to the availability of the outdoor placement.',
    s9_6_i7: 'Where an outdoor placement becomes unavailable due to a Force Majeure Event before its activation starts, either the Advertiser or the Placement Provider may remove it from the campaign without any cancellation fee, notwithstanding section 9.3, and the Advertiser shall receive a full refund of the amounts paid for it.',
    s9_6_i8: 'Where a Force Majeure Event lasts more than 14 days, or more than half of the remaining campaign period of the affected placement, the Advertiser may cancel the remainder of that placement at no cost and receive a refund for the remaining days.',
    s9_6_i9: 'For campaigns paid in monthly installments, future installments shall be reduced or cancelled accordingly.',
    s9_6_d: 'd) Scope',
    s9_6_p3: 'Events that affect only the Advertiser\'s own business, and not the outdoor placements, are not covered by this section; the Campaign Cancellation Policy in section 9.3 applies.',
    s9_7: '9.7 Vandalism',
    s9_7_p1: '"Vandalism" means the deliberate damage, defacement or removal of an outdoor placement or of the Advertiser\'s creative by third parties unconnected with the Advertiser or the Placement Provider - for example graffiti, torn or covered posters, or damaged screens or structures.',
    s9_7_i1: 'The Placement Provider must report Vandalism through the Platform within 48 hours of becoming aware of it, together with photographs and, where available, a police report.',
    s9_7_i2: 'The Placement Provider must restore the display within 3 business days of the report, at its own cost, including the reprinting and reinstallation of the creative.',
    s9_7_i3: 'Days on which display is prevented within that restoration period shall be treated as Force Majeure Days under section 9.6: the Advertiser is entitled to a full refund for them, without fees, and no Non-Performance Amount shall be due.',
    s9_7_i4: 'Days beyond the restoration period, or Vandalism resulting from the Placement Provider\'s failure to take reasonable preventive measures, shall constitute Non-Compliant Days under section 9.5.',
    s9_7_i5: 'Where the same outdoor placement is vandalised three or more times within 30 days, the Placement Provider must take reasonable preventive measures, and the Advertiser may cancel the remainder of that placement at no cost and receive a refund for the remaining days.',
    s9_7_p2: 'Reporting a Force Majeure Event or Vandalism that did not occur shall be treated as the submission of false proof-of-placement under section 12 and may result in immediate suspension or termination of the account.',
    proofProtectionNote: 'Your investment is protected: if any outdoor placement fails to provide verified proof of display, Scapow will refund the corresponding amount for that placement.',
    s10: 'Disputes',
    s10_p1: 'Users agree to first attempt resolution through the Platform. The Platform may:',
    s10_i1: 'Review campaign evidence;',
    s10_i2: 'Request additional documentation;',
    s10_i3: 'Issue a non-binding decision.',
    s10_p2: "The Platform's decision does not replace legal rights under applicable law.",
    s11: 'Intellectual Property',
    s11_p1: 'Advertisers retain ownership of their submitted content.',
    s11_p2: 'By uploading materials, Advertisers grant the Platform and Placement Providers a limited, non-exclusive license to use, reproduce, and display such materials solely for fulfilling the campaign.',
    s11_p3: 'Placement Providers retain ownership of their listings, images, and location data.',
    s11_p4: 'The Platform retains ownership of all platform software, branding, and systems.',
    s12: 'Prohibited Use',
    s12_p1: 'Users may not:',
    s12_i1: 'Commit fraud;',
    s12_i2: 'Upload misleading or illegal content;',
    s12_i3: 'Circumvent payments;',
    s12_i4: 'Contact users outside the Platform to avoid fees;',
    s12_i5: 'Manipulate reviews or campaign results;',
    s12_i6: 'Upload false proof-of-placement.',
    s12_p2: 'Violation may result in immediate suspension or termination.',
    s13: 'Liability',
    s13_p1: 'To the maximum extent permitted by law, the Platform shall not be liable for:',
    s13_i1: 'Campaign underperformance;',
    s13_i2: 'Weather damage, natural disasters and vandalism, which are governed by sections 9.6 and 9.7;',
    s13_i3: 'Delays caused by third parties;',
    s13_i4: 'Printing defects not caused by the Platform;',
    s13_i5: 'Acts or omissions of users.',
    s13_p2: 'Total liability shall not exceed the total fees paid to the Platform for the relevant campaign.',
    s14: 'Indemnification',
    s14_p1: 'Users agree to indemnify and hold harmless the Company against any claims, losses, damages, liabilities, or expenses arising from:',
    s14_i1: 'Breach of these Terms;',
    s14_i2: 'Illegal advertising content;',
    s14_i3: 'Infringement of third-party rights;',
    s14_i4: 'Fraudulent conduct.',
    s15: 'Account Suspension',
    s15_p1: 'The Platform may suspend or terminate accounts for:',
    s15_i1: 'Fraud;',
    s15_i2: 'Non-payment;',
    s15_i3: 'Repeated disputes;',
    s15_i4: 'Abuse of the Platform;',
    s15_i5: 'Violation of these Terms.',
    s16: 'Taxes',
    s16_p1: 'Users are responsible for their own taxes, including VAT, sales tax, income tax, and any other applicable taxes. The Platform may collect taxes where legally required.',
    s17: 'Data Protection',
    s17_p1: "User data will be processed in accordance with the Platform's Privacy Policy and applicable data protection laws. Users are responsible for ensuring they have lawful rights to any uploaded personal data.",
    s18: 'Governing Law',
    s18_p1: 'These Terms shall be governed by the applicable laws without regard to conflict of law principles. Disputes shall be subject to the exclusive jurisdiction of the competent courts.',
    s19: 'Amendments',
    s19_p1: 'The Platform may amend these Terms at any time. Continued use of the Platform after amendments constitutes acceptance.',
    s20: 'Contact',
    s20_p1: 'For legal inquiries:',
  },
  footer: {
    tagline:
      'The marketplace connecting outdoor ad owners with advertisers. Simple, efficient, impactful.',
    platform: 'Platform',
    browseOutdoors: 'Browse Outdoors',
    createAccount: 'Create Account',
    logIn: 'Log In',
    forBusinesses: 'For Businesses',
    registerBusiness: 'Register Business',
    listOutdoors: 'List Your Outdoors',
    runCampaigns: 'Run Campaigns',
    about: 'About',
    howItWorks: 'How It Works',
    mission: 'Our Mission',
    contactUs: 'Contact Us',
    copyright: '© 2026 Scapow by Codify. All rights reserved.',
    privacy: 'Privacy',
    terms: 'Terms',
  },
  language: {
    select: 'Language',
    en: 'English',
    pt: 'Português',
    es: 'Español',
    de: 'Deutsch',
    zh: '中文',
    ja: '日本語',
    fr: 'Français',
    it: 'Italiano',
  },
  verification: {
    title: 'Campaign Outdoor Verification',
    subtitle: 'Submit proof photos for your active campaign outdoors awaiting verification. All outdoor slots within a campaign must be verified before the campaign payment is released.',
    empty: 'No pending verifications',
    emptyDesc: 'All your active campaign outdoors are up to date. Check back once your campaigns go live.',
    uploadProof: 'Upload proof photo',
    uploaded: 'Proof submitted',
    uploadSuccess: 'Proof photo submitted successfully.',
    noName: 'Campaign Outdoor',
    locating: 'Locating…',
    awaitingVerification: 'Awaiting verification',
    verified: 'Verified',
    partiallyVerified: 'Partially verified',
    backToCampaigns: 'Back to campaigns',
    noOutdoors: 'No outdoor slots found for this campaign',
    pendingCount: '{{count}} pending',
    notYetAvailable: 'Verification opens on {{date}}',
    viewProof: 'View proof photo',
    proofAlt: 'Proof photo',
    deleteProof: 'Delete proof',
    deleteProofSuccess: 'Proof photo deleted.',
    deleteProofConfirm: 'Are you sure you want to delete this proof photo? This action cannot be undone.',
  },
  howItWorksPage: {
    title: 'How OOH Advertising Works on Scapow',
    subtitle: 'Whether you own static outdoor spaces or want to reach new audiences through out-of-home advertising, Scapow makes it simple.',
    advertiserTab: 'For Advertisers',
    ppTab: 'For Placement Providers',
    advertiserTitle: 'Reach Your Audience with Out-of-Home Advertising',
    advertiserSubtitle: 'Plan, launch, and track OOH ad campaigns across static outdoor billboards - all from one intuitive adtech platform.',
    adStep1Title: 'Discover the Right OOH Spaces',
    adStep1Desc: 'Browse thousands of vetted static outdoor locations on a live map. Filter by city, format, dimensions, availability, and daily rate to find the perfect spots for your out-of-home campaign.',
    adStep2Title: 'Build Your OOH Campaign',
    adStep2Desc: 'Select multiple outdoor placements and group them into a single campaign. Set your campaign dates, upload your print-ready creative artwork, and confirm your plan - no ad agency needed.',
    adStep3Title: 'Pay with Confidence',
    adStep3Desc: 'Receive a transparent payment breakdown before you commit. Pay safely via our platform and receive a formal invoice - everything documented and traceable for your ad spend records.',
    adStep4Title: 'Track Every OOH Placement',
    adStep4Desc: 'Once your out-of-home campaign is live, placement providers submit photo proof of your outdoor display. Monitor status and confirmations directly from your advertiser dashboard.',
    ppTitle: 'Turn Your Outdoor Spaces into OOH Advertising Revenue',
    ppSubtitle: 'List your static outdoor media once, reach thousands of advertisers searching for OOH placements, and earn on your own schedule.',
    ppStep1Title: 'List Your Static Outdoor Spaces',
    ppStep1Desc: 'Create detailed OOH listings for each of your outdoor billboard locations. Add dimensions, photos, pricing, and availability. The better your listing, the more out-of-home campaigns you attract.',
    ppStep2Title: 'Get Matched with OOH Campaigns',
    ppStep2Desc: 'Your static outdoor spaces appear in advertiser searches automatically. When selected for an OOH campaign, you receive a notification and a confirmed booking - no negotiation required.',
    ppStep3Title: 'Upload Proof of Display',
    ppStep3Desc: 'Once your outdoor is running the advertisement, upload a photo proof through the platform. This is your confirmation of delivery - and triggers the payment process.',
    ppStep4Title: 'Get Paid',
    ppStep4Desc: 'Once proof of display has been submitted for every outdoor slot in a campaign, payment is released according to agreed terms. All your placements across the OOH campaign must be verified before funds are processed - ensuring full delivery before payment.',
    ctaTitle: 'Ready to launch your OOH campaign?',
    ctaSubtitle: 'Join thousands of businesses already growing with Scapow - the out-of-home adtech marketplace.',
    ctaAdvertiser: 'Start Advertising',
    ctaProvider: 'List Your Spaces',
  },
  brand: {
    slogan: "it's ooh good!",
  },
  calendar: {
    calendarMonthsHint: 'Booked by whole calendar months, from the 1st to the last day. Click a 1st to start, a later day to add its month, or a day inside the booking to shorten it.',
    startOnMonthFirstHint: 'Bookings start on the 1st of a month.',
    fullMonthHint: 'Booked by the month: pick a start day, then click a later day to add months - each one ends on the same day of the next month (starting on a 1st, on the month’s last day). Click inside the booking to shorten it.',
    discountsTitle: 'Book longer, save more',
    discountTier: '{{days}}+ days',
    discountsPickStart: 'Pick a start date to see which end dates get a discount.',
    discountsHighlighted: 'Darker green means a bigger discount - the tags show where each one starts.',
    discountApplied: '{{percentage}}% off for these {{count}} days',
    discountNextTier: 'Add {{days}} more day(s) to save {{percentage}}%',
    latestStartInfo: 'Start dates up to {{date}}',
    blockedLegend: 'Blocked / unavailable',
    pendingLegend: 'Pending (not yet saved)',
    loading: 'Loading availability…',
    noticeRequired: 'Earliest start date: {{date}} ({{count}}-day booking notice required)',
    minimumDaysError: 'Minimum rental is {{count}} days - please extend your selection',
    overlapError: 'The selected range spans reserved dates - please choose consecutive available days only',
  },
  missionPage: {
    title: 'Our Mission',
    subtitle: 'Connecting the out-of-home advertising market - so every space creates impact and every campaign finds its audience.',
    coreTitle: 'What Drives Us',
    coreDesc: 'The outdoor advertising industry is fragmented. Great spaces go unbooked. Campaigns miss their potential. We believe technology can change that - and Scapow is how.',
    pillar1Title: 'Amplify Reach & Impact',
    pillar1Desc: 'We enable advertisers to plan and execute high-impact outdoor campaigns across multiple locations with a single, unified platform - reaching audiences at scale without the operational overhead.',
    pillar2Title: 'Maximise Provider Revenue',
    pillar2Desc: 'We give placement providers direct access to a qualified pool of advertising demand, reducing vacant inventory and ensuring their spaces deliver consistent, predictable revenue.',
    pillar3Title: 'Connect the Static OOH Market',
    pillar3Desc: 'We are building the infrastructure that the out-of-home industry has long needed - a transparent, digital-first marketplace where supply meets demand efficiently, fairly, and at scale.',
    pillar4Title: 'Trust Through Transparency',
    pillar4Desc: 'From verified business credentials to photo proof of display, every step of the Scapow process is designed to be auditable, accountable, and built on mutual trust between all parties.',
    visionTitle: 'Our Vision',
    visionDesc: 'A world where every outdoor space is an opportunity - and every brand can find its perfect canvas, wherever its audience lives, works, and moves.',
    closingTitle: 'Building the Future of OOH',
    closingDesc: 'Scapow is more than a marketplace. It is the connective tissue of the outdoor advertising industry - bringing together placement providers, advertisers, and the technology that powers their shared success.',
  },
  contact: {
    label: 'Get in Touch',
    title: 'Contact Us',
    subtitle: 'Have a question, feedback, or just want to say hello? We’d love to hear from you.',
    infoTitle: "Let's Talk",
    infoDesc: 'Whether you’re curious about features, pricing, or anything else - our team is ready to answer all your questions.',
    responseTimeTitle: 'Quick Response',
    responseTimeDesc: 'We typically respond within 24 hours.',
    emailTitle: 'Email Us',
    whatsappTitle: 'WhatsApp',
    formTitle: 'Send us a message',
    fieldName: 'Your Name',
    fieldEmail: 'Your Email',
    fieldSubject: 'Subject',
    fieldMessage: 'Message',
    namePlaceholder: 'John Smith',
    emailPlaceholder: 'you@example.com',
    subjectPlaceholder: 'How can we help?',
    messagePlaceholder: 'Tell us what you have in mind…',
    submit: 'Send Message',
    submitting: 'Sending…',
    successTitle: 'Message sent!',
    successDesc: 'Thank you for reaching out. We’ll be in touch shortly.',
    backHome: 'Back to Home',
    errorRequired: 'This field is required.',
    errorEmail: 'Please enter a valid email address.',
  },
  approvals: {
    thisBookingLegend: 'This booking',
    blockedSelection: 'Blocked period:',
    blockedSelectionEmpty: 'Pick the start and end dates in the calendar.',
    title: 'Approvals',
    subtitle: 'Confirm whether your outdoors are available for these paid campaigns.',
    emptyTitle: 'You’re all caught up',
    emptyDesc: 'When an advertiser books one of your outdoors, it will appear here for your approval.',
    campaignFallback: 'Campaign',
    outdoorsToReview: 'Outdoors to review: {{count}}',
    startsOn: 'Starts {{date}}',
    answerBy: 'Answer by {{date}}',
    review: 'Review',
    youEarn: 'You earn',
    backToList: 'Back to approvals',
    reviewEyebrow: 'Approval request',
    summaryLine: 'Outdoors: {{count}} · You earn {{value}}',
    deadlineNotice: 'Please answer by {{date}}. Outdoors not answered in time are released from the campaign.',
    progress: '{{answered}} of {{total}} answered',
    approveAll: 'Approve all',
    available: 'Available',
    unavailable: 'Unavailable',
    decisionFor: 'Is {{name}} available?',
    decisionRequired: 'Please choose an answer.',
    blockedHint: 'Tell us when this outdoor is already taken - we’ll block these dates on it.',
    blockedFrom: 'Blocked from',
    blockedTo: 'Blocked until',
    blockedRequired: 'Both dates are required.',
    blockedOrder: 'The end date must be on or after the start date.',
    viewCreative: 'View the creative for {{name}}',
    noCreative: 'No creative yet',
    feedbackMandatory: 'An answer is needed for every outdoor.',
    submit: 'Submit answers',
    fixBeforeSubmit: 'Please answer every outdoor and check the blocked dates.',
    confirmTitle: 'Submit your answers?',
    confirmSummary: 'Available: {{approved}} · Unavailable: {{unavailable}}',
    confirmNote: 'Answers can’t be changed once submitted.',
    submitted: 'Thanks - your answers were sent.',
    submitError: 'Could not submit your answers.',
    allAnsweredTitle: 'Already answered',
    allAnsweredDesc: 'You’ve answered for all your outdoors in this campaign.',
    loadErrorTitle: 'This approval isn’t available',
    loadErrorDesc: 'It may have been answered already, or the campaign was cancelled.',
  },
  status: {
    installment: {
      SCHEDULED: 'Scheduled',
      PROCESSING: 'Processing',
      PAID: 'Paid',
      FAILED: 'Failed',
      CANCELLED: 'Cancelled',
    },
    campaign: {
      PENDING: 'Draft',
      AWAITING_PAYMENT: 'Awaiting payment',
      CONFIRMING: 'Awaiting providers',
      AWAITING_CONFIRMATION: 'Decision needed',
      READY: 'Confirmed',
      RUNNING: 'Live',
      COMPLETED: 'Completed',
      CANCELLED: 'Cancelled',
      UNAVAILABLE: 'Unavailable',
    },
    payment: {
      PENDING: 'Not paid',
      VALIDATING_PAYMENT: 'Validating payment',
      MANUAL_VALIDATION: 'Under review',
      TRANSFER_REQUESTED: 'Transfer requested',
      PAID: 'Paid',
      CANCELLED: 'Cancelled',
      PARTIALLY_REFUNDED: 'Partially refunded',
      FULLY_REFUNDED: 'Refunded',
      FAILED: 'Failed',
    },
    campaignOutdoor: {
      PENDING: 'Awaiting proof',
      VERIFYING: 'Verifying proof',
      FOR_MANUAL_APPROVAL: 'Proof under review',
      APPROVED: 'Proof approved',
      REJECTED: 'Proof rejected',
      REFUNDED: 'Refunded',
      CANCELLED: 'Cancelled',
    },
    proof: {
      PENDING: 'Pending',
      VALID: 'Valid',
      MANUAL_VALIDATION: 'Under review',
      INVALID: 'Invalid',
    },
    paymentType: {
      BUYING_ADS: 'Ad purchase',
      SELLING_ADS: 'Provider payout',
      REFUND_BUYING_PART: 'Advertiser refund',
      REFUND_SELLING_PART: 'Provider refund',
      PLACEMENT_PROVIDER_DEBT: 'Provider debt',
      PLACEMENT_PROVIDER_CANCELLATION_FEE: 'Cancellation compensation',
    },
  },
  offlineCampaigns: {
    creativesTitle: 'Creatives',
    creativesSubtitle: 'Artwork to install. Any size works - you decide how it fits each outdoor.',
    uploadCreatives: 'Upload creatives',
    noCreatives: 'No creatives yet. Click to upload JPG, PNG, TIFF or PDF files.',
    creativesUploaded: 'Creatives uploaded.',
    creativeRemoved: 'Creative removed.',
    removeCreative: 'Remove creative',
    removeCreativeConfirm: 'Remove this creative? This can’t be undone.',
    downloadOriginal: 'Download original',
    filesTitle: 'Files',
    filesSubtitle: 'Contracts, briefs or any other file for this campaign.',
    uploadFiles: 'Upload files',
    noFiles: 'No files uploaded yet.',
    filesUploaded: 'Files uploaded.',
    fileRemoved: 'File removed.',
    removeFile: 'Remove file',
    removeFileConfirm: 'Remove “{{name}}”? This can’t be undone.',
    download: 'Download',
    remove: 'Remove',
    outdoorsTitle: 'Outdoors',
    noOutdoors: 'No outdoors in this campaign yet.',
    modalTitle: 'Add to an offline campaign',
    newTitle: 'New offline campaign',
    pickTitle: 'Pick an offline campaign',
    datesTitle: 'Choose the dates',
    doneTitle: 'Outdoor added',
    forOutdoor: 'Outdoor:',
    optionNew: 'New',
    optionNewDesc: 'Create a campaign for a booking sold outside Scapow.',
    optionPick: 'Pick from existing',
    optionPickDesc: 'Add it to one of your offline campaigns.',
    name: 'Campaign name',
    nameRequired: 'Give the campaign a name.',
    details: 'Details',
    detailsHint: 'E.g. the client or channel it was sold through.',
    notes: 'Notes',
    notesHint: 'Internal notes - only visible to your team.',
    instructions: 'Instructions',
    instructionsHint: 'For whoever installs the creative.',
    createAndContinue: 'Create and continue',
    createError: 'Could not create the offline campaign.',
    addError: 'Could not add the outdoor to the campaign.',
    noneYet: 'You have no offline campaigns yet.',
    outdoorsCount: 'Outdoors: {{count}}',
    createdOn: 'created {{date}}',
    datesIntro: 'Choose when the outdoor is booked for “{{campaign}}”. Dates already taken are shown and can’t be selected.',
    pickDates: 'Pick the start and end dates in the calendar.',
    addToCampaign: 'Add to campaign',
    doneMessage: '{{outdoor}} was added to “{{campaign}}”.',
    doneHint: 'These dates are now blocked for other bookings.',
    backToSearch: 'Back to search',
    getAvailability: 'Get availability',
    clearAvailability: 'Clear availability',
    availabilityTitle: 'Get availability',
    availabilityHint: 'Choose a start and end date to see only the outdoors free for the whole period.',
    showAvailable: 'Show available outdoors',
    dimensionsLabel: 'Sizes',
    noMatches: 'No outdoors match these filters',
    noMatchesHint: 'Try other sizes or dates, or clear the filters.',
    clearFilters: 'Clear filters',
    addButton: 'Add to offline campaign',
    addTooltip: 'Add to a campaign not booked by Scapow',
  },
};

export default en;
